// -- (function(scope){
// -- 'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.i5.cQ === region.fQ.cQ)
	{
		return 'on line ' + region.i5.cQ;
	}
	return 'on lines ' + region.i5.cQ + ' through ' + region.fQ.cQ;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ij,
		impl.jl,
		impl.hf,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


/*
function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}

*/

/*
function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}
*/


/*
function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}

*/

/*
function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}
*/




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'outerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		it: func(record.it),
		i8: record.i8,
		iR: record.iR
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.it;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.i8;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.iR) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ij,
		impl.jl,
		impl.hf,
		function(sendToApp, initialModel) {
			var view = impl.jn;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ij,
		impl.jl,
		impl.hf,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.e4 && impl.e4(sendToApp)
			var view = impl.jn;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.fx);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.je) && (_VirtualDom_doc.title = title = doc.je);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.iL;
	var onUrlRequest = impl.iM;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		e4: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.gP === next.gP
							&& curr.f1 === next.f1
							&& curr.gL.a === next.gL.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		ij: function(flags)
		{
			return A3(impl.ij, flags, _Browser_getUrl(), key);
		},
		jn: impl.jn,
		jl: impl.jl,
		hf: impl.hf
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { ig: 'hidden', hT: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { ig: 'mozHidden', hT: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { ig: 'msHidden', hT: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { ig: 'webkitHidden', hT: 'webkitvisibilitychange' }
		: { ig: 'hidden', hT: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		g1: _Browser_getScene(),
		hv: {
			hA: _Browser_window.pageXOffset,
			hB: _Browser_window.pageYOffset,
			fm: _Browser_doc.documentElement.clientWidth,
			eb: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		fm: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		eb: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			g1: {
				fm: node.scrollWidth,
				eb: node.scrollHeight
			},
			hv: {
				hA: node.scrollLeft,
				hB: node.scrollTop,
				fm: node.clientWidth,
				eb: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			g1: _Browser_getScene(),
			hv: {
				hA: x,
				hB: y,
				fm: _Browser_doc.documentElement.clientWidth,
				eb: _Browser_doc.documentElement.clientHeight
			},
			fP: {
				hA: x + rect.left,
				hB: y + rect.top,
				fm: rect.width,
				eb: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.iy) { flags += 'm'; }
	if (options.hR) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.fU.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.fU.b, xhr)); });
		$elm$core$Maybe$isJust(request.hm) && _Http_track(router, xhr, request.hm.a);

		try {
			xhr.open(request.go, request.hs, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.hs));
		}

		_Http_configureRequest(xhr, request);

		request.fx.a && xhr.setRequestHeader('Content-Type', request.fx.a);
		xhr.send(request.fx.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.f0; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.hj.a || 0;
	xhr.responseType = request.fU.d;
	xhr.withCredentials = request.hG;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		hs: xhr.responseURL,
		ha: xhr.status,
		i6: xhr.statusText,
		f0: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			i4: event.loaded,
			g6: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			iT: event.loaded,
			g6: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}var $author$project$ExportForm$ValidModel = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.F) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.J),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.J);
		} else {
			var treeLen = builder.F * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.O) : builder.O;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.F);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.J) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.J);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{O: nodeList, F: (len / $elm$core$Array$branchFactor) | 0, J: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {fY: fragment, f1: host, gI: path, gL: port_, gP: protocol, gQ: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $author$project$ExportForm$ErrorModel = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$compare = _Utils_compare;
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Types$energyToString = function (energy) {
	switch (energy) {
		case 1:
			return 'el';
		case 2:
			return 'ga';
		case 3:
			return 'wa';
		case 4:
			return 'he';
		case 5:
			return 'co';
		case 6:
			return 'hca';
		case 7:
			return 'lf';
		default:
			return '';
	}
};
var $author$project$ExportForm$Flags = function (translations) {
	return function (locale) {
		return function (csrfToken) {
			return function (energies) {
				return function (entities) {
					return function (meters) {
						return function (dataSeries) {
							return function (templates) {
								return function (today) {
									return function (hasPermissionForModifyingTemplates) {
										return function (createUrl) {
											return function (createScheduledUrl) {
												return function (scheduledExportDelay) {
													return function (state) {
														return {cz: createScheduledUrl, bW: createUrl, aG: csrfToken, bY: dataSeries, M: energies, bA: entities, dr: hasPermissionForModifyingTemplates, gl: locale, a$: meters, bK: scheduledExportDelay, al: state, cj: templates, a1: today, j: translations};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$ExportTemplate$DataSeries = F2(
	function (id, name) {
		return {f5: id, gv: name};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$field = _Json_decodeField;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$ExportTemplate$dataSeriesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$ExportTemplate$DataSeries)));
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$core$Basics$neq = _Utils_notEqual;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.i5, posixMinutes) < 0) {
					return posixMinutes + era.iK;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		fG: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		gs: month,
		hC: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).fG;
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).gs;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).hC;
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {fC: col, hZ: contextStack, gM: problem, gY: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.gY, s.fC, x, s.l));
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.iK, s.d);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{fC: 1, l: s.l, r: s.r, iK: s.iK + 1, gY: s.gY + 1, d: s.d}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{fC: s.fC + 1, l: s.l, r: s.r, iK: newOffset, gY: s.gY, d: s.d}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.gM;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.d),
			s.iK) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.iK, s1.iK, s0.d),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.iK, s.gY, s.fC, s.d);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{fC: newCol, l: s.l, r: s.r, iK: newOffset, gY: newRow, d: s.d});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('month ' + ($elm$core$String$fromInt(mn) + ' is out of range')) + (' (1 to 12)' + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))) : ((!A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('day ' + ($elm$core$String$fromInt(d) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(
				A2(
					$justinmimbs$date$Date$daysInMonth,
					y,
					$justinmimbs$date$Date$numberToMonth(mn))) + ')')) + ((' for ' + $justinmimbs$date$Date$monthToName(
				$justinmimbs$date$Date$numberToMonth(mn))) + ((((mn === 2) && (d === 29)) ? (' (' + ($elm$core$String$fromInt(y) + ' is not a leap year)')) : '') + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))))) : $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		var daysInYear = $justinmimbs$date$Date$isLeapYear(y) ? 366 : 365;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, daysInYear, od)) ? $elm$core$Result$Err(
			'Invalid ordinal date: ' + (('ordinal-day ' + ($elm$core$String$fromInt(od) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(daysInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(y)) + ('; received (year ' + ($elm$core$String$fromInt(y) + (', ordinal-day ' + ($elm$core$String$fromInt(od) + ')')))))))) : $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od);
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		var weeksInYear = $justinmimbs$date$Date$is53WeekYear(wy) ? 53 : 52;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, weeksInYear, wn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('week ' + ($elm$core$String$fromInt(wn) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(weeksInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(wy)) + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')')))))))))) : ((!A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('weekday ' + ($elm$core$String$fromInt(wdn) + ' is out of range')) + (' (1 to 7)' + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')'))))))))) : $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {fC: col, gM: problem, gY: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.gY, p.fC, p.gM);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{fC: 1, l: _List_Nil, r: 1, iK: 0, gY: 1, d: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {ii: index, iq: match, dC: number, hd: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{hR: false, iy: false},
		string);
};
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Enectiva$Conversion$parseStdDateWithFallback = F2(
	function (fallback, str) {
		return A2(
			$elm$core$Result$withDefault,
			fallback,
			$justinmimbs$date$Date$fromIsoString(
				function () {
					var _v0 = $elm$regex$Regex$fromString('T.+$');
					if (_v0.$ === 1) {
						return str;
					} else {
						var regex = _v0.a;
						return A3(
							$elm$regex$Regex$replace,
							regex,
							$elm$core$Basics$always(''),
							str);
					}
				}()));
	});
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Enectiva$Conversion$parseStdDate = $author$project$Enectiva$Conversion$parseStdDateWithFallback(
	A2(
		$justinmimbs$date$Date$fromPosix,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(0)));
var $author$project$Enectiva$Conversion$dateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Enectiva$Conversion$parseStdDate(s));
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Enectiva$Conversion$decodeResult = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$json$Json$Decode$succeed(a);
	} else {
		var err = result.a;
		return $elm$json$Json$Decode$fail(err);
	}
};
var $author$project$Types$Co = 5;
var $author$project$Types$El = 1;
var $author$project$Types$Ga = 2;
var $author$project$Types$Hca = 6;
var $author$project$Types$He = 4;
var $author$project$Types$Lf = 7;
var $author$project$Types$Wa = 3;
var $author$project$Types$energyFromString = function (str) {
	switch (str) {
		case 'el':
			return $elm$core$Result$Ok(1);
		case 'ga':
			return $elm$core$Result$Ok(2);
		case 'wa':
			return $elm$core$Result$Ok(3);
		case 'he':
			return $elm$core$Result$Ok(4);
		case 'co':
			return $elm$core$Result$Ok(5);
		case 'hca':
			return $elm$core$Result$Ok(6);
		case 'lf':
			return $elm$core$Result$Ok(7);
		default:
			return $elm$core$Result$Err('unknown energy ' + str);
	}
};
var $author$project$Types$energyDecoder = A3(
	$elm$core$Basics$composeR,
	$elm$json$Json$Decode$map($author$project$Types$energyFromString),
	$elm$json$Json$Decode$andThen($author$project$Enectiva$Conversion$decodeResult),
	$elm$json$Json$Decode$string);
var $author$project$Enectiva$Entity$Entity = F2(
	function (id, name) {
		return {f5: id, gv: name};
	});
var $author$project$Types$entityDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Enectiva$Entity$Entity)));
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Types$Meter = F4(
	function (id, name, energy, virtual) {
		return {cH: energy, f5: id, gv: name, jo: virtual};
	});
var $author$project$Types$meterDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'virtual',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'energy',
		$author$project$Types$energyDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Types$Meter)))));
var $author$project$ExportForm$TemplateSelection = {$: 0};
var $author$project$ExportForm$EditScheduledDataPointForm = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $author$project$ExportForm$ScheduledDataPointAttrs = F3(
	function (name, dataSeriesIds, mode) {
		return {p: dataSeriesIds, h: mode, gv: name};
	});
var $author$project$ExportForm$All = {$: 0};
var $author$project$ExportForm$First = function (a) {
	return {$: 1, a: a};
};
var $author$project$ExportForm$Last = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$Day = 1;
var $author$project$Types$Hour = 2;
var $author$project$Types$Min5 = 4;
var $author$project$Types$Month = 0;
var $author$project$Types$Quarter = 3;
var $author$project$Types$stringToPeriod = function (str) {
	switch (str) {
		case 'month':
			return 0;
		case 'day':
			return 1;
		case 'hour':
			return 2;
		case 'quarter':
			return 3;
		case 'min5':
			return 4;
		default:
			return 0;
	}
};
var $author$project$ExportForm$periodDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Types$stringToPeriod,
	A2($elm$json$Json$Decode$field, 'period', $elm$json$Json$Decode$string));
var $author$project$ExportForm$continuousModeDecoder = function (field) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (m) {
			switch (m) {
				case 'all':
					return $elm$json$Json$Decode$succeed($author$project$ExportForm$All);
				case 'first':
					return A2($elm$json$Json$Decode$map, $author$project$ExportForm$First, $author$project$ExportForm$periodDecoder);
				case 'last':
					return A2($elm$json$Json$Decode$map, $author$project$ExportForm$Last, $author$project$ExportForm$periodDecoder);
				default:
					return $elm$json$Json$Decode$fail('unsupported mode ' + m);
			}
		},
		A2($elm$json$Json$Decode$field, field, $elm$json$Json$Decode$string));
};
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$ExportForm$scheduledDataPointAttrsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$ExportForm$continuousModeDecoder('data_points_mode'),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'data_series_ids',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Set$fromList,
			$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$ExportForm$ScheduledDataPointAttrs))));
var $author$project$ExportForm$editScheduledDataPointDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	$krisajenkins$remotedata$RemoteData$NotAsked,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$ExportForm$scheduledDataPointAttrsDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'url',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$ExportForm$EditScheduledDataPointForm))));
var $author$project$ExportForm$EditScheduledReadingForm = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$ExportForm$ScheduledReadingAttrs = F3(
	function (name, meterIds, mode) {
		return {f: meterIds, h: mode, gv: name};
	});
var $author$project$ExportForm$scheduledReadingAttrsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$ExportForm$continuousModeDecoder('readings_mode'),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'meter_ids',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Set$fromList,
			$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$ExportForm$ScheduledReadingAttrs))));
var $author$project$ExportForm$editScheduledReadingDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	$krisajenkins$remotedata$RemoteData$NotAsked,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$ExportForm$scheduledReadingAttrsDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'url',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$ExportForm$EditScheduledReadingForm))));
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $author$project$ExportForm$stateDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$author$project$ExportForm$editScheduledReadingDecoder,
			$author$project$ExportForm$editScheduledDataPointDecoder,
			$elm$json$Json$Decode$succeed($author$project$ExportForm$TemplateSelection)
		]));
var $author$project$ExportForm$Template = F4(
	function (id, name, type_, dimensions) {
		return {fK: dimensions, f5: id, gv: name, hr: type_};
	});
var $author$project$Types$DataSeriesDimension = 3;
var $author$project$Types$EnergiesDimension = 4;
var $author$project$Types$EntitiesDimension = 1;
var $author$project$Types$MeasuresDimension = 5;
var $author$project$Types$MetersDimension = 2;
var $author$project$Types$TimeDimension = 0;
var $author$project$Types$UnknownDimension = 6;
var $author$project$ExportTemplate$dimensionDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'time':
				return $elm$json$Json$Decode$succeed(0);
			case 'entities':
				return $elm$json$Json$Decode$succeed(1);
			case 'meters':
				return $elm$json$Json$Decode$succeed(2);
			case 'data_series':
				return $elm$json$Json$Decode$succeed(3);
			case 'energies':
				return $elm$json$Json$Decode$succeed(4);
			case 'measures':
				return $elm$json$Json$Decode$succeed(5);
			default:
				return $elm$json$Json$Decode$succeed(6);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$ExportForm$DataPoints = 2;
var $author$project$ExportForm$Deltas = 0;
var $author$project$ExportForm$Readings = 1;
var $author$project$ExportForm$stringToTemplateType = function (str) {
	switch (str) {
		case 'deltas':
			return $elm$core$Result$Ok(0);
		case 'readings':
			return $elm$core$Result$Ok(1);
		case 'data_points':
			return $elm$core$Result$Ok(2);
		default:
			return $elm$core$Result$Err(str);
	}
};
var $author$project$ExportForm$templateTypeDecoder = A3(
	$elm$core$Basics$composeR,
	$elm$json$Json$Decode$map($author$project$ExportForm$stringToTemplateType),
	$elm$json$Json$Decode$andThen($author$project$Enectiva$Conversion$decodeResult),
	$elm$json$Json$Decode$string);
var $author$project$ExportForm$templateDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'dimensions',
	$elm$json$Json$Decode$list($author$project$ExportTemplate$dimensionDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		$author$project$ExportForm$templateTypeDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$ExportForm$Template)))));
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$ExportForm$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'export',
	$author$project$ExportForm$stateDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'scheduledExportDelay',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'createScheduledUrl',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'createUrl',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'hasPermissionForModifyingTemplates',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'today',
						$author$project$Enectiva$Conversion$dateDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'templates',
							$elm$json$Json$Decode$list($author$project$ExportForm$templateDecoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'dataSeries',
								$elm$json$Json$Decode$list($author$project$ExportTemplate$dataSeriesDecoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'meters',
									$elm$json$Json$Decode$list($author$project$Types$meterDecoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'entities',
										$elm$json$Json$Decode$list($author$project$Types$entityDecoder),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'energies',
											$elm$json$Json$Decode$list($author$project$Types$energyDecoder),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'csrfToken',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'locale',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'translations',
														$elm$json$Json$Decode$value,
														$elm$json$Json$Decode$succeed($author$project$ExportForm$Flags)))))))))))))));
var $author$project$Enectiva$I18n$Translations = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Enectiva$I18n$newTranslations = $author$project$Enectiva$I18n$Translations;
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Enectiva$Util$noCmd = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$ExportForm$init = function (json) {
	return $author$project$Enectiva$Util$noCmd(
		function () {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$ExportForm$flagsDecoder, json);
			if (!_v0.$) {
				var flags = _v0.a;
				return $author$project$ExportForm$ValidModel(
					{
						cz: flags.cz,
						bW: flags.bW,
						aG: flags.aG,
						bY: flags.bY,
						M: flags.M,
						bA: flags.bA,
						dr: flags.dr,
						a$: A2(
							$elm$core$List$sortWith,
							F2(
								function (a, b) {
									var energyComparison = A2(
										$elm$core$Basics$compare,
										$author$project$Types$energyToString(a.cH),
										$author$project$Types$energyToString(b.cH));
									if (energyComparison === 1) {
										return A2($elm$core$Basics$compare, a.gv, b.gv);
									} else {
										return energyComparison;
									}
								}),
							flags.a$),
						bK: flags.bK,
						al: flags.al,
						cj: flags.cj,
						a1: flags.a1,
						j: A2($author$project$Enectiva$I18n$newTranslations, flags.gl, flags.j)
					});
			} else {
				var err = _v0.a;
				return $author$project$ExportForm$ErrorModel(
					$elm$json$Json$Decode$errorToString(err));
			}
		}());
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$ExportForm$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$ExportForm$DiscreteFormMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$ExportForm$EditScheduledDataPointFormMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$ExportForm$EditScheduledReadingFormMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$ServerErrors$JsonContent = function (a) {
	return {$: 0, a: a};
};
var $author$project$ExportForm$OneoffDataPointFormMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$ExportForm$OneoffReadingFormMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$ExportForm$ScheduledDataPointFormMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$ExportForm$ScheduledReadingFormMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$ExportForm$ServerRespondedToDiscreteForm = function (a) {
	return {$: 11, a: a};
};
var $author$project$ExportForm$ServerRespondedToOneoffDataPointForm = function (a) {
	return {$: 6, a: a};
};
var $author$project$ExportForm$ServerRespondedToOneoffReadingForm = function (a) {
	return {$: 6, a: a};
};
var $author$project$ExportForm$ServerRespondedToScheduledDataPointForm = function (a) {
	return {$: 6, a: a};
};
var $author$project$ExportForm$ServerRespondedToScheduledReadingForm = function (a) {
	return {$: 6, a: a};
};
var $author$project$ExportForm$ServerRespondedToUpdateScheduledDataPointForm = function (a) {
	return {$: 5, a: a};
};
var $author$project$ExportForm$ServerRespondedToUpdateScheduledReadingForm = function (a) {
	return {$: 5, a: a};
};
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$json$Json$Encode$string = _Json_wrap;
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {fG: d, gs: m, hC: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		eG: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		hC: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.hC, 0, date.eG);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.fG;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.gs;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.eG;
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		hw: 1 + (((rd - week1Day1) / 7) | 0),
		hx: wy,
		jp: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.hw;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.hx;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.dB(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.eB(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.dB(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.d2(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.bQ(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.bQ(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.bQ(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.fl(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.bQ(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.bQ(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.d);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.iK, offset) < 0,
					0,
					{fC: col, l: s0.l, r: s0.r, iK: offset, gY: row, d: s0.d});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.iK, s.gY, s.fC, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.iK, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	d2: $justinmimbs$date$Date$withOrdinalSuffix,
	eB: $justinmimbs$date$Date$monthToName,
	dB: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	fl: $justinmimbs$date$Date$weekdayToName,
	bQ: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Enectiva$DateRange$encoder = function (_v0) {
	var from = _v0.a;
	var to = _v0.b;
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'from',
			$elm$json$Json$Encode$string(
				$justinmimbs$date$Date$toIsoString(from))),
			_Utils_Tuple2(
			'to',
			$elm$json$Json$Encode$string(
				$justinmimbs$date$Date$toIsoString(to)))
		]);
};
var $author$project$Types$energyEncoder = function (energy) {
	return $elm$json$Json$Encode$string(
		$author$project$Types$energyToString(energy));
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Types$measureToString = function (measure) {
	switch (measure) {
		case 0:
			return 'consumption';
		case 1:
			return 'cost';
		case 2:
			return 'production';
		case 3:
			return 'production_cost';
		default:
			return 'readings';
	}
};
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Types$periodToString = function (period) {
	switch (period) {
		case 0:
			return 'month';
		case 1:
			return 'day';
		case 2:
			return 'hour';
		case 4:
			return 'min5';
		default:
			return 'quarter';
	}
};
var $author$project$ExportForm$encodeDiscreteAttrs = F2(
	function (templateId, _v0) {
		var name = _v0.gv;
		var range = _v0.C;
		var period = _v0.aO;
		var entityIds = _v0.aq;
		var meterIds = _v0.f;
		var measures = _v0.az;
		var energies = _v0.M;
		var meterCombinations = A2(
			$elm$core$List$concatMap,
			function (meterId) {
				return A2(
					$elm$core$List$map,
					function (measure) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'meter_id',
									$elm$json$Json$Encode$int(meterId)),
									_Utils_Tuple2(
									'measure',
									$elm$json$Json$Encode$string(
										$author$project$Types$measureToString(measure)))
								]));
					},
					measures);
			},
			$elm$core$Set$toList(meterIds));
		var entityCombinations = A2(
			$elm$core$List$concatMap,
			function (entityId) {
				return A2(
					$elm$core$List$concatMap,
					function (energy) {
						return A2(
							$elm$core$List$map,
							function (measure) {
								return $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'entity_id',
											$elm$json$Json$Encode$int(entityId)),
											_Utils_Tuple2(
											'energy',
											$author$project$Types$energyEncoder(energy)),
											_Utils_Tuple2(
											'measure',
											$elm$json$Json$Encode$string(
												$author$project$Types$measureToString(measure)))
										]));
							},
							measures);
					},
					energies);
			},
			$elm$core$Set$toList(entityIds));
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				$author$project$Enectiva$DateRange$encoder(range),
				_List_fromArray(
					[
						_Utils_Tuple2(
						'export_template_id',
						$elm$json$Json$Encode$int(templateId)),
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(name)),
						_Utils_Tuple2(
						'period',
						$elm$json$Json$Encode$string(
							$author$project$Types$periodToString(period))),
						_Utils_Tuple2(
						'combinations',
						A2(
							$elm$json$Json$Encode$list,
							$elm$core$Basics$identity,
							_Utils_ap(entityCombinations, meterCombinations)))
					])));
	});
var $author$project$ExportForm$continuousModeEncoder = F2(
	function (key, mode) {
		switch (mode.$) {
			case 0:
				return _List_fromArray(
					[
						_Utils_Tuple2(
						key,
						$elm$json$Json$Encode$string('all'))
					]);
			case 1:
				var period = mode.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						key,
						$elm$json$Json$Encode$string('first')),
						_Utils_Tuple2(
						'period',
						$elm$json$Json$Encode$string(
							$author$project$Types$periodToString(period)))
					]);
			default:
				var period = mode.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						key,
						$elm$json$Json$Encode$string('last')),
						_Utils_Tuple2(
						'period',
						$elm$json$Json$Encode$string(
							$author$project$Types$periodToString(period)))
					]);
		}
	});
var $author$project$ExportForm$encodeOneoffDataPointAttrs = F2(
	function (templateId, _v0) {
		var name = _v0.gv;
		var range = _v0.C;
		var dataSeriesIds = _v0.p;
		var mode = _v0.h;
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				$author$project$Enectiva$DateRange$encoder(range),
				_Utils_ap(
					A2($author$project$ExportForm$continuousModeEncoder, 'data_points_mode', mode),
					_List_fromArray(
						[
							_Utils_Tuple2(
							'export_template_id',
							$elm$json$Json$Encode$int(templateId)),
							_Utils_Tuple2(
							'name',
							$elm$json$Json$Encode$string(name)),
							_Utils_Tuple2(
							'combinations',
							A2(
								$elm$json$Json$Encode$list,
								function (id) {
									return $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'data_series_id',
												$elm$json$Json$Encode$int(id)),
												_Utils_Tuple2(
												'measure',
												$elm$json$Json$Encode$string('data_points'))
											]));
								},
								$elm$core$Set$toList(dataSeriesIds)))
						]))));
	});
var $author$project$ExportForm$encodeOneoffReadingAttrs = F2(
	function (templateId, _v0) {
		var name = _v0.gv;
		var range = _v0.C;
		var meterIds = _v0.f;
		var mode = _v0.h;
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				$author$project$Enectiva$DateRange$encoder(range),
				_Utils_ap(
					A2($author$project$ExportForm$continuousModeEncoder, 'readings_mode', mode),
					_List_fromArray(
						[
							_Utils_Tuple2(
							'export_template_id',
							$elm$json$Json$Encode$int(templateId)),
							_Utils_Tuple2(
							'name',
							$elm$json$Json$Encode$string(name)),
							_Utils_Tuple2(
							'combinations',
							A2(
								$elm$json$Json$Encode$list,
								function (id) {
									return $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'meter_id',
												$elm$json$Json$Encode$int(id)),
												_Utils_Tuple2(
												'measure',
												$elm$json$Json$Encode$string('readings'))
											]));
								},
								$elm$core$Set$toList(meterIds)))
						]))));
	});
var $author$project$ExportForm$encodeScheduledDataPointAttrs = function (_v0) {
	var name = _v0.gv;
	var dataSeriesIds = _v0.p;
	var mode = _v0.h;
	return _Utils_ap(
		A2($author$project$ExportForm$continuousModeEncoder, 'data_points_mode', mode),
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(name)),
				_Utils_Tuple2(
				'combinations',
				A2(
					$elm$json$Json$Encode$list,
					function (id) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'data_series_id',
									$elm$json$Json$Encode$int(id)),
									_Utils_Tuple2(
									'measure',
									$elm$json$Json$Encode$string('data_points'))
								]));
					},
					$elm$core$Set$toList(dataSeriesIds)))
			]));
};
var $author$project$ExportForm$encodeScheduledDataPointExport = F2(
	function (templateId, attrs) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'export_template_id',
					$elm$json$Json$Encode$int(templateId)),
				$author$project$ExportForm$encodeScheduledDataPointAttrs(attrs)));
	});
var $author$project$ExportForm$encodeScheduledReadingAttrs = function (_v0) {
	var name = _v0.gv;
	var meterIds = _v0.f;
	var mode = _v0.h;
	return _Utils_ap(
		A2($author$project$ExportForm$continuousModeEncoder, 'readings_mode', mode),
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(name)),
				_Utils_Tuple2(
				'combinations',
				A2(
					$elm$json$Json$Encode$list,
					function (id) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'meter_id',
									$elm$json$Json$Encode$int(id)),
									_Utils_Tuple2(
									'measure',
									$elm$json$Json$Encode$string('readings'))
								]));
					},
					$elm$core$Set$toList(meterIds)))
			]));
};
var $author$project$ExportForm$encodeScheduledReadingExport = F2(
	function (templateId, attrs) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'export_template_id',
					$elm$json$Json$Encode$int(templateId)),
				$author$project$ExportForm$encodeScheduledReadingAttrs(attrs)));
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$ServerErrors$General = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $author$project$ServerErrors$PerField = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Timeout = {$: 1};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$ServerErrors$errorsDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['errors', 'validation']),
	$elm$json$Json$Decode$dict(
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $author$project$Enectiva$HttpExtra$errorToString = function (err) {
	switch (err.$) {
		case 0:
			var str = err.a;
			return 'Bad URL ' + str;
		case 1:
			return 'Timeout';
		case 2:
			return 'Network error';
		case 3:
			return 'Bad status';
		default:
			var str = err.a;
			return 'Bad body ' + str;
	}
};
var $author$project$ServerErrors$generalError = A2(
	$elm$core$Basics$composeR,
	$author$project$Enectiva$HttpExtra$errorToString,
	A2($elm$core$Basics$composeR, $author$project$ServerErrors$General, $elm$core$Result$Err));
var $author$project$ServerErrors$httpClientSideError = function (code) {
	return (400 <= code) && (code < 500);
};
var $author$project$ServerErrors$expectResponse = F2(
	function (tagger, expectation) {
		return A2(
			$elm$http$Http$expectStringResponse,
			tagger,
			function (response) {
				switch (response.$) {
					case 0:
						var u = response.a;
						return $author$project$ServerErrors$generalError(
							$elm$http$Http$BadUrl(u));
					case 1:
						return $author$project$ServerErrors$generalError($elm$http$Http$Timeout);
					case 2:
						return $author$project$ServerErrors$generalError($elm$http$Http$NetworkError);
					case 3:
						var metadata = response.a;
						var body = response.b;
						if ($author$project$ServerErrors$httpClientSideError(metadata.ha)) {
							var _v1 = A2($elm$json$Json$Decode$decodeString, $author$project$ServerErrors$errorsDecoder, body);
							if (!_v1.$) {
								var se = _v1.a;
								return $elm$core$Result$Err(
									$author$project$ServerErrors$PerField(se));
							} else {
								var de = _v1.a;
								return $elm$core$Result$Err(
									$author$project$ServerErrors$General(
										$elm$json$Json$Decode$errorToString(de)));
							}
						} else {
							return $author$project$ServerErrors$generalError(
								$elm$http$Http$BadStatus(metadata.ha));
						}
					default:
						var body = response.b;
						if (expectation.$ === 1) {
							var v = expectation.a;
							return $elm$core$Result$Ok(v);
						} else {
							var decoder = expectation.a;
							var _v3 = A2($elm$json$Json$Decode$decodeString, decoder, body);
							if (!_v3.$) {
								var value = _v3.a;
								return $elm$core$Result$Ok(value);
							} else {
								var err = _v3.a;
								return $author$project$ServerErrors$generalError(
									$elm$http$Http$BadBody(
										$elm$json$Json$Decode$errorToString(err)));
							}
						}
				}
			});
	});
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $author$project$Ports$redirectTo = _Platform_outgoingPort('redirectTo', $elm$json$Json$Encode$string);
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {gU: reqs, he: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.hm;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.gU));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.he)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					hG: r.hG,
					fx: r.fx,
					fU: A2(_Http_mapExpect, func, r.fU),
					f0: r.f0,
					go: r.go,
					hj: r.hj,
					hm: r.hm,
					hs: r.hs
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{hG: false, fx: r.fx, fU: r.fU, f0: r.f0, go: r.go, hj: r.hj, hm: r.hm, hs: r.hs}));
};
var $author$project$ExportForm$effectToCmd = function (_v0) {
	var model = _v0.a;
	var effect = _v0.b;
	switch (effect.$) {
		case 0:
			return $author$project$Enectiva$Util$noCmd(model);
		case 1:
			var templateId = effect.a;
			var attrs = effect.b;
			return _Utils_Tuple2(
				model,
				$elm$http$Http$request(
					{
						fx: $elm$http$Http$jsonBody(
							A2($author$project$ExportForm$encodeOneoffReadingAttrs, templateId, attrs)),
						fU: A2(
							$author$project$ServerErrors$expectResponse,
							A2($elm$core$Basics$composeR, $author$project$ExportForm$ServerRespondedToOneoffReadingForm, $author$project$ExportForm$OneoffReadingFormMsg),
							$author$project$ServerErrors$JsonContent(
								A2($elm$json$Json$Decode$field, 'export_url', $elm$json$Json$Decode$string))),
						f0: _List_fromArray(
							[
								A2($elm$http$Http$header, 'X-CSRF-Token', model.aG),
								A2($elm$http$Http$header, 'X-Requested-With', 'XMLHttpRequest')
							]),
						go: 'POST',
						hj: $elm$core$Maybe$Nothing,
						hm: $elm$core$Maybe$Nothing,
						hs: model.bW
					}));
		case 2:
			var templateId = effect.a;
			var attrs = effect.b;
			return _Utils_Tuple2(
				model,
				$elm$http$Http$request(
					{
						fx: $elm$http$Http$jsonBody(
							A2($author$project$ExportForm$encodeOneoffDataPointAttrs, templateId, attrs)),
						fU: A2(
							$author$project$ServerErrors$expectResponse,
							A2($elm$core$Basics$composeR, $author$project$ExportForm$ServerRespondedToOneoffDataPointForm, $author$project$ExportForm$OneoffDataPointFormMsg),
							$author$project$ServerErrors$JsonContent(
								A2($elm$json$Json$Decode$field, 'export_url', $elm$json$Json$Decode$string))),
						f0: _List_fromArray(
							[
								A2($elm$http$Http$header, 'X-CSRF-Token', model.aG),
								A2($elm$http$Http$header, 'X-Requested-With', 'XMLHttpRequest')
							]),
						go: 'POST',
						hj: $elm$core$Maybe$Nothing,
						hm: $elm$core$Maybe$Nothing,
						hs: model.bW
					}));
		case 3:
			var templateId = effect.a;
			var attrs = effect.b;
			return _Utils_Tuple2(
				model,
				$elm$http$Http$request(
					{
						fx: $elm$http$Http$jsonBody(
							A2($author$project$ExportForm$encodeScheduledReadingExport, templateId, attrs)),
						fU: A2(
							$author$project$ServerErrors$expectResponse,
							A2($elm$core$Basics$composeR, $author$project$ExportForm$ServerRespondedToScheduledReadingForm, $author$project$ExportForm$ScheduledReadingFormMsg),
							$author$project$ServerErrors$JsonContent(
								A2($elm$json$Json$Decode$field, 'export_url', $elm$json$Json$Decode$string))),
						f0: _List_fromArray(
							[
								A2($elm$http$Http$header, 'X-CSRF-Token', model.aG),
								A2($elm$http$Http$header, 'X-Requested-With', 'XMLHttpRequest')
							]),
						go: 'POST',
						hj: $elm$core$Maybe$Nothing,
						hm: $elm$core$Maybe$Nothing,
						hs: model.cz
					}));
		case 4:
			var templateId = effect.a;
			var attrs = effect.b;
			return _Utils_Tuple2(
				model,
				$elm$http$Http$request(
					{
						fx: $elm$http$Http$jsonBody(
							A2($author$project$ExportForm$encodeScheduledDataPointExport, templateId, attrs)),
						fU: A2(
							$author$project$ServerErrors$expectResponse,
							A2($elm$core$Basics$composeR, $author$project$ExportForm$ServerRespondedToScheduledDataPointForm, $author$project$ExportForm$ScheduledDataPointFormMsg),
							$author$project$ServerErrors$JsonContent(
								A2($elm$json$Json$Decode$field, 'export_url', $elm$json$Json$Decode$string))),
						f0: _List_fromArray(
							[
								A2($elm$http$Http$header, 'X-CSRF-Token', model.aG),
								A2($elm$http$Http$header, 'X-Requested-With', 'XMLHttpRequest')
							]),
						go: 'POST',
						hj: $elm$core$Maybe$Nothing,
						hm: $elm$core$Maybe$Nothing,
						hs: model.cz
					}));
		case 5:
			var url = effect.a;
			var attrs = effect.b;
			return _Utils_Tuple2(
				model,
				$elm$http$Http$request(
					{
						fx: $elm$http$Http$jsonBody(
							$elm$json$Json$Encode$object(
								$author$project$ExportForm$encodeScheduledReadingAttrs(attrs))),
						fU: A2(
							$author$project$ServerErrors$expectResponse,
							A2($elm$core$Basics$composeR, $author$project$ExportForm$ServerRespondedToUpdateScheduledReadingForm, $author$project$ExportForm$EditScheduledReadingFormMsg),
							$author$project$ServerErrors$JsonContent(
								A2($elm$json$Json$Decode$field, 'export_url', $elm$json$Json$Decode$string))),
						f0: _List_fromArray(
							[
								A2($elm$http$Http$header, 'X-CSRF-Token', model.aG),
								A2($elm$http$Http$header, 'X-Requested-With', 'XMLHttpRequest')
							]),
						go: 'PATCH',
						hj: $elm$core$Maybe$Nothing,
						hm: $elm$core$Maybe$Nothing,
						hs: url
					}));
		case 6:
			var url = effect.a;
			var attrs = effect.b;
			return _Utils_Tuple2(
				model,
				$elm$http$Http$request(
					{
						fx: $elm$http$Http$jsonBody(
							$elm$json$Json$Encode$object(
								$author$project$ExportForm$encodeScheduledDataPointAttrs(attrs))),
						fU: A2(
							$author$project$ServerErrors$expectResponse,
							A2($elm$core$Basics$composeR, $author$project$ExportForm$ServerRespondedToUpdateScheduledDataPointForm, $author$project$ExportForm$EditScheduledDataPointFormMsg),
							$author$project$ServerErrors$JsonContent(
								A2($elm$json$Json$Decode$field, 'export_url', $elm$json$Json$Decode$string))),
						f0: _List_fromArray(
							[
								A2($elm$http$Http$header, 'X-CSRF-Token', model.aG),
								A2($elm$http$Http$header, 'X-Requested-With', 'XMLHttpRequest')
							]),
						go: 'PATCH',
						hj: $elm$core$Maybe$Nothing,
						hm: $elm$core$Maybe$Nothing,
						hs: url
					}));
		case 7:
			var templateId = effect.a;
			var attrs = effect.b;
			return _Utils_Tuple2(
				model,
				$elm$http$Http$request(
					{
						fx: $elm$http$Http$jsonBody(
							A2($author$project$ExportForm$encodeDiscreteAttrs, templateId, attrs)),
						fU: A2(
							$author$project$ServerErrors$expectResponse,
							A2($elm$core$Basics$composeR, $author$project$ExportForm$ServerRespondedToDiscreteForm, $author$project$ExportForm$DiscreteFormMsg),
							$author$project$ServerErrors$JsonContent(
								A2($elm$json$Json$Decode$field, 'export_url', $elm$json$Json$Decode$string))),
						f0: _List_fromArray(
							[
								A2($elm$http$Http$header, 'X-CSRF-Token', model.aG),
								A2($elm$http$Http$header, 'X-Requested-With', 'XMLHttpRequest')
							]),
						go: 'POST',
						hj: $elm$core$Maybe$Nothing,
						hm: $elm$core$Maybe$Nothing,
						hs: model.bW
					}));
		default:
			var url = effect.a;
			return _Utils_Tuple2(
				model,
				$author$project$Ports$redirectTo(url));
	}
};
var $author$project$ExportForm$DiscreteExportForm = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$ExportForm$OneoffDataPointForm = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$ExportForm$OneoffReadingForm = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$ExportForm$ScheduledDataPointForm = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$ExportForm$ScheduledReadingForm = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $justinmimbs$date$Date$fromRataDie = function (rd) {
	return rd;
};
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $author$project$Enectiva$DateRange$nDaysAgo = F2(
	function (diff, date) {
		return $justinmimbs$date$Date$fromRataDie(
			function (a) {
				return a - diff;
			}(
				$justinmimbs$date$Date$toRataDie(date)));
	});
var $author$project$Enectiva$DateRange$aYearAgo = $author$project$Enectiva$DateRange$nDaysAgo(365);
var $author$project$Enectiva$DateRange$new = F2(
	function (from, to) {
		return _Utils_Tuple2(from, to);
	});
var $author$project$Enectiva$DateRange$default = function (end) {
	return A2(
		$author$project$Enectiva$DateRange$new,
		$author$project$Enectiva$DateRange$aYearAgo(end),
		end);
};
var $author$project$Enectiva$DateRange$isLongerThanOneDay = function (_v0) {
	var from = _v0.a;
	var to = _v0.b;
	return ($justinmimbs$date$Date$toRataDie(to) - $justinmimbs$date$Date$toRataDie(from)) >= 1;
};
var $author$project$ExportForm$NoEffect = {$: 0};
var $author$project$ExportForm$noEffect = function (m) {
	return _Utils_Tuple2(m, $author$project$ExportForm$NoEffect);
};
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $author$project$ExportForm$RedirectTo = function (a) {
	return {$: 8, a: a};
};
var $author$project$ExportForm$SubmitDiscreteForm = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $author$project$ExportForm$allEntityIds = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		function ($) {
			return $.f5;
		}),
	$elm$core$Set$fromList);
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$ExportForm$applyShortcutToMeters = F3(
	function (context, meterFilter, msg) {
		switch (msg.$) {
			case 0:
				return $elm$core$Set$fromList(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.f5;
						},
						A2($elm$core$List$filter, meterFilter, context.a$)));
			case 1:
				return $elm$core$Set$empty;
			default:
				var energy = msg.a;
				return $elm$core$Set$fromList(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.f5;
						},
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.cH;
								},
								$elm$core$Basics$eq(energy)),
							A2($elm$core$List$filter, meterFilter, context.a$))));
		}
	});
var $elm_community$list_extra$List$Extra$reverseAppend = F2(
	function (list1, list2) {
		return A3($elm$core$List$foldl, $elm$core$List$cons, list2, list1);
	});
var $elm_community$list_extra$List$Extra$removeHelp = F4(
	function (list, x, xs, previousElements) {
		removeHelp:
		while (true) {
			if (!xs.b) {
				return list;
			} else {
				var y = xs.a;
				var ys = xs.b;
				if (_Utils_eq(x, y)) {
					return A2($elm_community$list_extra$List$Extra$reverseAppend, previousElements, ys);
				} else {
					var $temp$list = list,
						$temp$x = x,
						$temp$xs = ys,
						$temp$previousElements = A2($elm$core$List$cons, y, previousElements);
					list = $temp$list;
					x = $temp$x;
					xs = $temp$xs;
					previousElements = $temp$previousElements;
					continue removeHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$remove = F2(
	function (x, xs) {
		return A4($elm_community$list_extra$List$Extra$removeHelp, xs, x, xs, _List_Nil);
	});
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$ExportForm$updateDiscreteForm = F5(
	function (msg, template, attrs, submitRequest, context) {
		switch (msg.$) {
			case 0:
				var name = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$DiscreteExportForm,
						template,
						_Utils_update(
							attrs,
							{gv: name}),
						submitRequest));
			case 1:
				var period = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$DiscreteExportForm,
						template,
						_Utils_update(
							attrs,
							{aO: period}),
						submitRequest));
			case 2:
				var id = msg.a;
				var selected = msg.b;
				var entityIds = selected ? A2($elm$core$Set$insert, id, attrs.aq) : A2($elm$core$Set$remove, id, attrs.aq);
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$DiscreteExportForm,
						template,
						_Utils_update(
							attrs,
							{aq: entityIds}),
						submitRequest));
			case 3:
				var id = msg.a;
				var selected = msg.b;
				var meterIds = selected ? A2($elm$core$Set$insert, id, attrs.f) : A2($elm$core$Set$remove, id, attrs.f);
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$DiscreteExportForm,
						template,
						_Utils_update(
							attrs,
							{f: meterIds}),
						submitRequest));
			case 4:
				var energy = msg.a;
				var selected = msg.b;
				var energies = selected ? A2($elm$core$List$cons, energy, attrs.M) : A2($elm_community$list_extra$List$Extra$remove, energy, attrs.M);
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$DiscreteExportForm,
						template,
						_Utils_update(
							attrs,
							{M: energies}),
						submitRequest));
			case 5:
				var energy = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$DiscreteExportForm,
						template,
						_Utils_update(
							attrs,
							{
								M: $elm$core$List$singleton(energy)
							}),
						submitRequest));
			case 6:
				var measure = msg.a;
				var selected = msg.b;
				var measures = selected ? A2($elm$core$List$cons, measure, attrs.az) : A2($elm_community$list_extra$List$Extra$remove, measure, attrs.az);
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$DiscreteExportForm,
						template,
						_Utils_update(
							attrs,
							{az: measures}),
						submitRequest));
			case 7:
				var measure = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$DiscreteExportForm,
						template,
						_Utils_update(
							attrs,
							{
								az: $elm$core$List$singleton(measure)
							}),
						submitRequest));
			case 8:
				switch (msg.a.$) {
					case 0:
						var _v1 = msg.a;
						return $author$project$ExportForm$noEffect(
							A3(
								$author$project$ExportForm$DiscreteExportForm,
								template,
								_Utils_update(
									attrs,
									{
										aq: $author$project$ExportForm$allEntityIds(context.bA)
									}),
								submitRequest));
					case 1:
						var _v2 = msg.a;
						return $author$project$ExportForm$noEffect(
							A3(
								$author$project$ExportForm$DiscreteExportForm,
								template,
								_Utils_update(
									attrs,
									{aq: $elm$core$Set$empty}),
								submitRequest));
					default:
						return $author$project$ExportForm$noEffect(
							A3($author$project$ExportForm$DiscreteExportForm, template, attrs, submitRequest));
				}
			case 9:
				var shortcutMsg = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$DiscreteExportForm,
						template,
						_Utils_update(
							attrs,
							{
								f: A3(
									$author$project$ExportForm$applyShortcutToMeters,
									context,
									$elm$core$Basics$always(true),
									shortcutMsg)
							}),
						submitRequest));
			case 10:
				return _Utils_Tuple2(
					A3($author$project$ExportForm$DiscreteExportForm, template, attrs, $krisajenkins$remotedata$RemoteData$Loading),
					A2($author$project$ExportForm$SubmitDiscreteForm, template.f5, attrs));
			default:
				if (msg.a.$ === 1) {
					var errors = msg.a.a;
					return $author$project$ExportForm$noEffect(
						A3(
							$author$project$ExportForm$DiscreteExportForm,
							template,
							attrs,
							$krisajenkins$remotedata$RemoteData$Failure(errors)));
				} else {
					var redirectUrl = msg.a.a;
					return _Utils_Tuple2(
						A3(
							$author$project$ExportForm$DiscreteExportForm,
							template,
							attrs,
							$krisajenkins$remotedata$RemoteData$Success(0)),
						$author$project$ExportForm$RedirectTo(redirectUrl));
				}
		}
	});
var $author$project$ExportForm$SubmitUpdateScheduledDataPointForm = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$ExportForm$applyShortcutToDataSeries = F2(
	function (context, msg) {
		switch (msg.$) {
			case 0:
				return $elm$core$Set$fromList(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.f5;
						},
						context.bY));
			case 1:
				return $elm$core$Set$empty;
			default:
				return $elm$core$Set$empty;
		}
	});
var $author$project$ExportForm$updateEditScheduledDataPointForm = F5(
	function (msg, url, attrs, submitRequest, context) {
		switch (msg.$) {
			case 0:
				var name = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$EditScheduledDataPointForm,
						url,
						_Utils_update(
							attrs,
							{gv: name}),
						submitRequest));
			case 1:
				var id = msg.a;
				var selected = msg.b;
				var dataSeriesIds = selected ? A2($elm$core$Set$insert, id, attrs.p) : A2($elm$core$Set$remove, id, attrs.p);
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$EditScheduledDataPointForm,
						url,
						_Utils_update(
							attrs,
							{p: dataSeriesIds}),
						submitRequest));
			case 2:
				var shortcutMsg = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$EditScheduledDataPointForm,
						url,
						_Utils_update(
							attrs,
							{
								p: A2($author$project$ExportForm$applyShortcutToDataSeries, context, shortcutMsg)
							}),
						submitRequest));
			case 3:
				var mode = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$EditScheduledDataPointForm,
						url,
						_Utils_update(
							attrs,
							{h: mode}),
						submitRequest));
			case 4:
				return _Utils_Tuple2(
					A3($author$project$ExportForm$EditScheduledDataPointForm, url, attrs, $krisajenkins$remotedata$RemoteData$Loading),
					A2($author$project$ExportForm$SubmitUpdateScheduledDataPointForm, url, attrs));
			default:
				if (msg.a.$ === 1) {
					var errors = msg.a.a;
					return $author$project$ExportForm$noEffect(
						A3(
							$author$project$ExportForm$EditScheduledDataPointForm,
							url,
							attrs,
							$krisajenkins$remotedata$RemoteData$Failure(errors)));
				} else {
					var redirectUrl = msg.a.a;
					return _Utils_Tuple2(
						A3(
							$author$project$ExportForm$EditScheduledDataPointForm,
							url,
							attrs,
							$krisajenkins$remotedata$RemoteData$Success(0)),
						$author$project$ExportForm$RedirectTo(redirectUrl));
				}
		}
	});
var $author$project$ExportForm$SubmitUpdateScheduledReadingForm = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$ExportForm$isPhysicalMeter = function (_v0) {
	var virtual = _v0.jo;
	return !virtual;
};
var $author$project$ExportForm$updateEditScheduledReadingForm = F5(
	function (msg, url, attrs, submitRequest, context) {
		switch (msg.$) {
			case 0:
				var name = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$EditScheduledReadingForm,
						url,
						_Utils_update(
							attrs,
							{gv: name}),
						submitRequest));
			case 1:
				var id = msg.a;
				var selected = msg.b;
				var meterIds = selected ? A2($elm$core$Set$insert, id, attrs.f) : A2($elm$core$Set$remove, id, attrs.f);
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$EditScheduledReadingForm,
						url,
						_Utils_update(
							attrs,
							{f: meterIds}),
						submitRequest));
			case 2:
				var shortcutMsg = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$EditScheduledReadingForm,
						url,
						_Utils_update(
							attrs,
							{
								f: A3($author$project$ExportForm$applyShortcutToMeters, context, $author$project$ExportForm$isPhysicalMeter, shortcutMsg)
							}),
						submitRequest));
			case 3:
				var mode = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$EditScheduledReadingForm,
						url,
						_Utils_update(
							attrs,
							{h: mode}),
						submitRequest));
			case 4:
				return _Utils_Tuple2(
					A3($author$project$ExportForm$EditScheduledReadingForm, url, attrs, $krisajenkins$remotedata$RemoteData$Loading),
					A2($author$project$ExportForm$SubmitUpdateScheduledReadingForm, url, attrs));
			default:
				if (msg.a.$ === 1) {
					var errors = msg.a.a;
					return $author$project$ExportForm$noEffect(
						A3(
							$author$project$ExportForm$EditScheduledReadingForm,
							url,
							attrs,
							$krisajenkins$remotedata$RemoteData$Failure(errors)));
				} else {
					var redirectUrl = msg.a.a;
					return _Utils_Tuple2(
						A3(
							$author$project$ExportForm$EditScheduledReadingForm,
							url,
							attrs,
							$krisajenkins$remotedata$RemoteData$Success(0)),
						$author$project$ExportForm$RedirectTo(redirectUrl));
				}
		}
	});
var $author$project$ExportForm$SubmitOneoffDataPointForm = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$ExportForm$updateOneoffDataPointForm = F5(
	function (msg, template, attrs, submitRequest, context) {
		switch (msg.$) {
			case 0:
				if (!msg.a) {
					var _v1 = msg.a;
					return $author$project$ExportForm$noEffect(
						A3($author$project$ExportForm$OneoffDataPointForm, template, attrs, submitRequest));
				} else {
					var _v2 = msg.a;
					var mode = function () {
						var _v3 = attrs.h;
						if (!_v3.$) {
							return $author$project$ExportForm$First(0);
						} else {
							return attrs.h;
						}
					}();
					var scheduledAttrs = {p: attrs.p, h: mode, gv: attrs.gv};
					return $author$project$ExportForm$noEffect(
						A3($author$project$ExportForm$ScheduledDataPointForm, template, scheduledAttrs, $krisajenkins$remotedata$RemoteData$NotAsked));
				}
			case 1:
				var name = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$OneoffDataPointForm,
						template,
						_Utils_update(
							attrs,
							{gv: name}),
						submitRequest));
			case 2:
				var id = msg.a;
				var selected = msg.b;
				var dataSeriesIds = selected ? A2($elm$core$Set$insert, id, attrs.p) : A2($elm$core$Set$remove, id, attrs.p);
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$OneoffDataPointForm,
						template,
						_Utils_update(
							attrs,
							{p: dataSeriesIds}),
						submitRequest));
			case 3:
				var shortcutMsg = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$OneoffDataPointForm,
						template,
						_Utils_update(
							attrs,
							{
								p: A2($author$project$ExportForm$applyShortcutToDataSeries, context, shortcutMsg)
							}),
						submitRequest));
			case 4:
				var mode = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$OneoffDataPointForm,
						template,
						_Utils_update(
							attrs,
							{h: mode}),
						submitRequest));
			case 5:
				return _Utils_Tuple2(
					A3($author$project$ExportForm$OneoffDataPointForm, template, attrs, $krisajenkins$remotedata$RemoteData$Loading),
					A2($author$project$ExportForm$SubmitOneoffDataPointForm, template.f5, attrs));
			default:
				if (msg.a.$ === 1) {
					var errors = msg.a.a;
					return $author$project$ExportForm$noEffect(
						A3(
							$author$project$ExportForm$OneoffDataPointForm,
							template,
							attrs,
							$krisajenkins$remotedata$RemoteData$Failure(errors)));
				} else {
					var redirectUrl = msg.a.a;
					return _Utils_Tuple2(
						A3(
							$author$project$ExportForm$OneoffDataPointForm,
							template,
							attrs,
							$krisajenkins$remotedata$RemoteData$Success(0)),
						$author$project$ExportForm$RedirectTo(redirectUrl));
				}
		}
	});
var $author$project$ExportForm$SubmitOneoffReadingForm = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$ExportForm$updateOneoffReadingForm = F5(
	function (msg, template, attrs, submitRequest, context) {
		switch (msg.$) {
			case 0:
				if (!msg.a) {
					var _v1 = msg.a;
					return $author$project$ExportForm$noEffect(
						A3($author$project$ExportForm$OneoffReadingForm, template, attrs, submitRequest));
				} else {
					var _v2 = msg.a;
					var mode = function () {
						var _v3 = attrs.h;
						if (!_v3.$) {
							return $author$project$ExportForm$First(0);
						} else {
							return attrs.h;
						}
					}();
					var scheduledAttrs = {f: attrs.f, h: mode, gv: attrs.gv};
					return $author$project$ExportForm$noEffect(
						A3($author$project$ExportForm$ScheduledReadingForm, template, scheduledAttrs, $krisajenkins$remotedata$RemoteData$NotAsked));
				}
			case 1:
				var name = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$OneoffReadingForm,
						template,
						_Utils_update(
							attrs,
							{gv: name}),
						submitRequest));
			case 2:
				var id = msg.a;
				var selected = msg.b;
				var meterIds = selected ? A2($elm$core$Set$insert, id, attrs.f) : A2($elm$core$Set$remove, id, attrs.f);
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$OneoffReadingForm,
						template,
						_Utils_update(
							attrs,
							{f: meterIds}),
						submitRequest));
			case 3:
				var shortcutMsg = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$OneoffReadingForm,
						template,
						_Utils_update(
							attrs,
							{
								f: A3($author$project$ExportForm$applyShortcutToMeters, context, $author$project$ExportForm$isPhysicalMeter, shortcutMsg)
							}),
						submitRequest));
			case 4:
				var mode = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$OneoffReadingForm,
						template,
						_Utils_update(
							attrs,
							{h: mode}),
						submitRequest));
			case 5:
				return _Utils_Tuple2(
					A3($author$project$ExportForm$OneoffReadingForm, template, attrs, $krisajenkins$remotedata$RemoteData$Loading),
					A2($author$project$ExportForm$SubmitOneoffReadingForm, template.f5, attrs));
			default:
				if (msg.a.$ === 1) {
					var errors = msg.a.a;
					return $author$project$ExportForm$noEffect(
						A3(
							$author$project$ExportForm$OneoffReadingForm,
							template,
							attrs,
							$krisajenkins$remotedata$RemoteData$Failure(errors)));
				} else {
					var redirectUrl = msg.a.a;
					return _Utils_Tuple2(
						A3(
							$author$project$ExportForm$OneoffReadingForm,
							template,
							attrs,
							$krisajenkins$remotedata$RemoteData$Success(0)),
						$author$project$ExportForm$RedirectTo(redirectUrl));
				}
		}
	});
var $author$project$ExportForm$SubmitScheduledDataPointForm = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$ExportForm$updateScheduledDataPointForm = F5(
	function (msg, template, attrs, submitRequest, context) {
		switch (msg.$) {
			case 0:
				if (msg.a === 1) {
					var _v1 = msg.a;
					return $author$project$ExportForm$noEffect(
						A3($author$project$ExportForm$ScheduledDataPointForm, template, attrs, submitRequest));
				} else {
					var _v2 = msg.a;
					var scheduledAttrs = {
						p: attrs.p,
						h: attrs.h,
						gv: attrs.gv,
						C: $author$project$Enectiva$DateRange$default(context.a1)
					};
					return $author$project$ExportForm$noEffect(
						A3($author$project$ExportForm$OneoffDataPointForm, template, scheduledAttrs, $krisajenkins$remotedata$RemoteData$NotAsked));
				}
			case 1:
				var name = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$ScheduledDataPointForm,
						template,
						_Utils_update(
							attrs,
							{gv: name}),
						submitRequest));
			case 2:
				var id = msg.a;
				var selected = msg.b;
				var dataSeriesIds = selected ? A2($elm$core$Set$insert, id, attrs.p) : A2($elm$core$Set$remove, id, attrs.p);
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$ScheduledDataPointForm,
						template,
						_Utils_update(
							attrs,
							{p: dataSeriesIds}),
						submitRequest));
			case 3:
				var shortcutMsg = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$ScheduledDataPointForm,
						template,
						_Utils_update(
							attrs,
							{
								p: A2($author$project$ExportForm$applyShortcutToDataSeries, context, shortcutMsg)
							}),
						submitRequest));
			case 4:
				var mode = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$ScheduledDataPointForm,
						template,
						_Utils_update(
							attrs,
							{h: mode}),
						submitRequest));
			case 5:
				return _Utils_Tuple2(
					A3($author$project$ExportForm$ScheduledDataPointForm, template, attrs, $krisajenkins$remotedata$RemoteData$Loading),
					A2($author$project$ExportForm$SubmitScheduledDataPointForm, template.f5, attrs));
			default:
				if (msg.a.$ === 1) {
					var errors = msg.a.a;
					return $author$project$ExportForm$noEffect(
						A3(
							$author$project$ExportForm$ScheduledDataPointForm,
							template,
							attrs,
							$krisajenkins$remotedata$RemoteData$Failure(errors)));
				} else {
					var redirectUrl = msg.a.a;
					return _Utils_Tuple2(
						A3(
							$author$project$ExportForm$ScheduledDataPointForm,
							template,
							attrs,
							$krisajenkins$remotedata$RemoteData$Success(0)),
						$author$project$ExportForm$RedirectTo(redirectUrl));
				}
		}
	});
var $author$project$ExportForm$SubmitScheduledReadingForm = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$ExportForm$updateScheduledReadingForm = F5(
	function (msg, template, attrs, submitRequest, context) {
		switch (msg.$) {
			case 0:
				if (msg.a === 1) {
					var _v1 = msg.a;
					return $author$project$ExportForm$noEffect(
						A3($author$project$ExportForm$ScheduledReadingForm, template, attrs, submitRequest));
				} else {
					var _v2 = msg.a;
					var oneoffAttrs = {
						f: attrs.f,
						h: attrs.h,
						gv: attrs.gv,
						C: $author$project$Enectiva$DateRange$default(context.a1)
					};
					return $author$project$ExportForm$noEffect(
						A3($author$project$ExportForm$OneoffReadingForm, template, oneoffAttrs, $krisajenkins$remotedata$RemoteData$NotAsked));
				}
			case 1:
				var name = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$ScheduledReadingForm,
						template,
						_Utils_update(
							attrs,
							{gv: name}),
						submitRequest));
			case 2:
				var id = msg.a;
				var selected = msg.b;
				var meterIds = selected ? A2($elm$core$Set$insert, id, attrs.f) : A2($elm$core$Set$remove, id, attrs.f);
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$ScheduledReadingForm,
						template,
						_Utils_update(
							attrs,
							{f: meterIds}),
						submitRequest));
			case 3:
				var shortcutMsg = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$ScheduledReadingForm,
						template,
						_Utils_update(
							attrs,
							{
								f: A3($author$project$ExportForm$applyShortcutToMeters, context, $author$project$ExportForm$isPhysicalMeter, shortcutMsg)
							}),
						submitRequest));
			case 4:
				var mode = msg.a;
				return $author$project$ExportForm$noEffect(
					A3(
						$author$project$ExportForm$ScheduledReadingForm,
						template,
						_Utils_update(
							attrs,
							{h: mode}),
						submitRequest));
			case 5:
				return _Utils_Tuple2(
					A3($author$project$ExportForm$ScheduledReadingForm, template, attrs, $krisajenkins$remotedata$RemoteData$Loading),
					A2($author$project$ExportForm$SubmitScheduledReadingForm, template.f5, attrs));
			default:
				if (msg.a.$ === 1) {
					var errors = msg.a.a;
					return $author$project$ExportForm$noEffect(
						A3(
							$author$project$ExportForm$ScheduledReadingForm,
							template,
							attrs,
							$krisajenkins$remotedata$RemoteData$Failure(errors)));
				} else {
					var redirectUrl = msg.a.a;
					return _Utils_Tuple2(
						A3(
							$author$project$ExportForm$ScheduledReadingForm,
							template,
							attrs,
							$krisajenkins$remotedata$RemoteData$Success(0)),
						$author$project$ExportForm$RedirectTo(redirectUrl));
				}
		}
	});
var $author$project$ExportForm$updateState = F3(
	function (fn, context, model) {
		var _v0 = fn(context);
		var state = _v0.a;
		var effect = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{al: state}),
			effect);
	});
var $author$project$ExportForm$DataPointExportPeriodicitySelection = function (a) {
	return {$: 3, a: a};
};
var $author$project$ExportForm$ReadingExportPeriodicitySelection = function (a) {
	return {$: 2, a: a};
};
var $author$project$ExportForm$DiscreteEntities = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$ExportForm$DiscreteMeters = function (a) {
	return {$: 1, a: a};
};
var $author$project$ExportForm$NonsensicalConfiguration = {$: 2};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$ExportForm$discreteDimensionConfiguration = function (_v0) {
	var dimensions = _v0.fK;
	return A2($elm$core$List$member, 1, dimensions) ? A2(
		$author$project$ExportForm$DiscreteEntities,
		A2($elm$core$List$member, 5, dimensions),
		A2($elm$core$List$member, 4, dimensions)) : (A2($elm$core$List$member, 2, dimensions) ? $author$project$ExportForm$DiscreteMeters(
		A2($elm$core$List$member, 5, dimensions)) : $author$project$ExportForm$NonsensicalConfiguration);
};
var $author$project$Types$Consumption = 0;
var $author$project$Types$Cost = 1;
var $author$project$ExportForm$discreteMeasures = _List_fromArray(
	[0, 1]);
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$ExportForm$discreteTemplateSelected = F2(
	function (_v0, template) {
		var templates = _v0.cj;
		var today = _v0.a1;
		var entities = _v0.bA;
		var meters = _v0.a$;
		var energies = _v0.M;
		var attrs = function () {
			var _v1 = $author$project$ExportForm$discreteDimensionConfiguration(template);
			switch (_v1.$) {
				case 0:
					var measuresDimensionIncluded = _v1.a;
					var energiesDimensionIncluded = _v1.b;
					return {
						M: energiesDimensionIncluded ? energies : A2($elm$core$List$take, 1, energies),
						aq: $author$project$ExportForm$allEntityIds(entities),
						az: measuresDimensionIncluded ? $author$project$ExportForm$discreteMeasures : A2($elm$core$List$take, 1, $author$project$ExportForm$discreteMeasures),
						f: $elm$core$Set$empty,
						gv: template.gv,
						aO: 0,
						C: $author$project$Enectiva$DateRange$default(today)
					};
				case 1:
					var measuresDimensionIncluded = _v1.a;
					return {
						M: _List_Nil,
						aq: $elm$core$Set$empty,
						az: measuresDimensionIncluded ? $author$project$ExportForm$discreteMeasures : A2($elm$core$List$take, 1, $author$project$ExportForm$discreteMeasures),
						f: $elm$core$Set$fromList(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.f5;
								},
								meters)),
						gv: template.gv,
						aO: 0,
						C: $author$project$Enectiva$DateRange$default(today)
					};
				default:
					return {
						M: _List_Nil,
						aq: $elm$core$Set$empty,
						az: _List_Nil,
						f: $elm$core$Set$empty,
						gv: '',
						aO: 0,
						C: $author$project$Enectiva$DateRange$default(today)
					};
			}
		}();
		return A3($author$project$ExportForm$DiscreteExportForm, template, attrs, $krisajenkins$remotedata$RemoteData$NotAsked);
	});
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$ExportForm$updateTemplateSelection = F2(
	function (msg, context) {
		var templates = context.cj;
		var today = context.a1;
		var entities = context.bA;
		var meters = context.a$;
		var energies = context.M;
		var id = msg;
		var _v1 = A2(
			$elm_community$list_extra$List$Extra$find,
			function (t) {
				return _Utils_eq(t.f5, id);
			},
			templates);
		if (_v1.$ === 1) {
			return $author$project$ExportForm$noEffect($author$project$ExportForm$TemplateSelection);
		} else {
			var template = _v1.a;
			var _v2 = template.hr;
			switch (_v2) {
				case 1:
					return $author$project$ExportForm$noEffect(
						$author$project$ExportForm$ReadingExportPeriodicitySelection(template));
				case 0:
					return $author$project$ExportForm$noEffect(
						A2($author$project$ExportForm$discreteTemplateSelected, context, template));
				default:
					return $author$project$ExportForm$noEffect(
						$author$project$ExportForm$DataPointExportPeriodicitySelection(template));
			}
		}
	});
var $author$project$ExportForm$updateEffect = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(msg, model.al);
		_v0$16:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var m = _v0.a.a;
						var _v1 = _v0.b;
						return A3(
							$author$project$ExportForm$updateState,
							$author$project$ExportForm$updateTemplateSelection(m),
							model,
							model);
					} else {
						break _v0$16;
					}
				case 1:
					var _v2 = _v0.a;
					return A3(
						$author$project$ExportForm$updateState,
						$elm$core$Basics$always(
							$author$project$ExportForm$noEffect($author$project$ExportForm$TemplateSelection)),
						model,
						model);
				case 2:
					if (!_v0.a.a) {
						if (_v0.b.$ === 2) {
							var _v3 = _v0.a.a;
							var template = _v0.b.a;
							var attrs = {
								f: $elm$core$Set$empty,
								h: $author$project$ExportForm$All,
								gv: template.gv,
								C: $author$project$Enectiva$DateRange$default(model.a1)
							};
							return $author$project$ExportForm$noEffect(
								_Utils_update(
									model,
									{
										al: A3($author$project$ExportForm$OneoffReadingForm, template, attrs, $krisajenkins$remotedata$RemoteData$NotAsked)
									}));
						} else {
							break _v0$16;
						}
					} else {
						if (_v0.b.$ === 2) {
							var _v4 = _v0.a.a;
							var template = _v0.b.a;
							var attrs = {
								f: $elm$core$Set$empty,
								h: $author$project$ExportForm$First(0),
								gv: template.gv
							};
							return $author$project$ExportForm$noEffect(
								_Utils_update(
									model,
									{
										al: A3($author$project$ExportForm$ScheduledReadingForm, template, attrs, $krisajenkins$remotedata$RemoteData$NotAsked)
									}));
						} else {
							break _v0$16;
						}
					}
				case 3:
					if (!_v0.a.a) {
						if (_v0.b.$ === 3) {
							var _v5 = _v0.a.a;
							var template = _v0.b.a;
							var attrs = {
								p: $elm$core$Set$empty,
								h: $author$project$ExportForm$All,
								gv: template.gv,
								C: $author$project$Enectiva$DateRange$default(model.a1)
							};
							return $author$project$ExportForm$noEffect(
								_Utils_update(
									model,
									{
										al: A3($author$project$ExportForm$OneoffDataPointForm, template, attrs, $krisajenkins$remotedata$RemoteData$NotAsked)
									}));
						} else {
							break _v0$16;
						}
					} else {
						if (_v0.b.$ === 3) {
							var _v6 = _v0.a.a;
							var template = _v0.b.a;
							var attrs = {
								p: $elm$core$Set$empty,
								h: $author$project$ExportForm$First(0),
								gv: template.gv
							};
							return $author$project$ExportForm$noEffect(
								_Utils_update(
									model,
									{
										al: A3($author$project$ExportForm$ScheduledDataPointForm, template, attrs, $krisajenkins$remotedata$RemoteData$NotAsked)
									}));
						} else {
							break _v0$16;
						}
					}
				case 4:
					if (_v0.b.$ === 4) {
						var m = _v0.a.a;
						var _v7 = _v0.b;
						var template = _v7.a;
						var attrs = _v7.b;
						var submitRequest = _v7.c;
						return A3(
							$author$project$ExportForm$updateState,
							A4($author$project$ExportForm$updateOneoffReadingForm, m, template, attrs, submitRequest),
							model,
							model);
					} else {
						break _v0$16;
					}
				case 5:
					if (_v0.b.$ === 5) {
						var m = _v0.a.a;
						var _v8 = _v0.b;
						var template = _v8.a;
						var attrs = _v8.b;
						var submitRequest = _v8.c;
						return A3(
							$author$project$ExportForm$updateState,
							A4($author$project$ExportForm$updateOneoffDataPointForm, m, template, attrs, submitRequest),
							model,
							model);
					} else {
						break _v0$16;
					}
				case 6:
					if (_v0.b.$ === 6) {
						var m = _v0.a.a;
						var _v9 = _v0.b;
						var template = _v9.a;
						var attrs = _v9.b;
						var submitRequest = _v9.c;
						return A3(
							$author$project$ExportForm$updateState,
							A4($author$project$ExportForm$updateScheduledReadingForm, m, template, attrs, submitRequest),
							model,
							model);
					} else {
						break _v0$16;
					}
				case 7:
					if (_v0.b.$ === 7) {
						var m = _v0.a.a;
						var _v10 = _v0.b;
						var template = _v10.a;
						var attrs = _v10.b;
						var submitRequest = _v10.c;
						return A3(
							$author$project$ExportForm$updateState,
							A4($author$project$ExportForm$updateScheduledDataPointForm, m, template, attrs, submitRequest),
							model,
							model);
					} else {
						break _v0$16;
					}
				case 8:
					if (_v0.b.$ === 8) {
						var m = _v0.a.a;
						var _v11 = _v0.b;
						var url = _v11.a;
						var attrs = _v11.b;
						var submitRequest = _v11.c;
						return A3(
							$author$project$ExportForm$updateState,
							A4($author$project$ExportForm$updateEditScheduledReadingForm, m, url, attrs, submitRequest),
							model,
							model);
					} else {
						break _v0$16;
					}
				case 9:
					if (_v0.b.$ === 9) {
						var m = _v0.a.a;
						var _v12 = _v0.b;
						var url = _v12.a;
						var attrs = _v12.b;
						var submitRequest = _v12.c;
						return A3(
							$author$project$ExportForm$updateState,
							A4($author$project$ExportForm$updateEditScheduledDataPointForm, m, url, attrs, submitRequest),
							model,
							model);
					} else {
						break _v0$16;
					}
				case 10:
					if (_v0.b.$ === 1) {
						var m = _v0.a.a;
						var _v13 = _v0.b;
						var template = _v13.a;
						var attrs = _v13.b;
						var submitRequest = _v13.c;
						return A3(
							$author$project$ExportForm$updateState,
							A4($author$project$ExportForm$updateDiscreteForm, m, template, attrs, submitRequest),
							model,
							model);
					} else {
						break _v0$16;
					}
				default:
					switch (_v0.b.$) {
						case 4:
							var range = _v0.a.a;
							var _v14 = _v0.b;
							var template = _v14.a;
							var attrs = _v14.b;
							var maybeErrors = _v14.c;
							return $author$project$ExportForm$noEffect(
								_Utils_update(
									model,
									{
										al: A3(
											$author$project$ExportForm$OneoffReadingForm,
											template,
											_Utils_update(
												attrs,
												{C: range}),
											maybeErrors)
									}));
						case 5:
							var range = _v0.a.a;
							var _v15 = _v0.b;
							var template = _v15.a;
							var attrs = _v15.b;
							var maybeErrors = _v15.c;
							return $author$project$ExportForm$noEffect(
								_Utils_update(
									model,
									{
										al: A3(
											$author$project$ExportForm$OneoffDataPointForm,
											template,
											_Utils_update(
												attrs,
												{C: range}),
											maybeErrors)
									}));
						case 1:
							var range = _v0.a.a;
							var _v16 = _v0.b;
							var template = _v16.a;
							var attrs = _v16.b;
							var submitRequest = _v16.c;
							var period = ((!(!attrs.aO)) || $author$project$Enectiva$DateRange$isLongerThanOneDay(range)) ? attrs.aO : 1;
							return $author$project$ExportForm$noEffect(
								_Utils_update(
									model,
									{
										al: A3(
											$author$project$ExportForm$DiscreteExportForm,
											template,
											_Utils_update(
												attrs,
												{aO: period, C: range}),
											submitRequest)
									}));
						default:
							break _v0$16;
					}
			}
		}
		return $author$project$ExportForm$noEffect(model);
	});
var $author$project$ExportForm$update = F2(
	function (msg, model) {
		return $author$project$ExportForm$effectToCmd(
			A2($author$project$ExportForm$updateEffect, msg, model));
	});
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$ExportForm$DataPointExportPeriodicitySelectionMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$ExportForm$ReadingExportPeriodicitySelectionMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$ExportForm$TemplateSelectionMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$ExportForm$PickAnotherTemplateButtonClicked = {$: 1};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Enectiva$I18n$keyToKeyPath = $elm$core$String$split('.');
var $author$project$Enectiva$I18n$tHelp = F2(
	function (_v0, keyPath) {
		var translations = _v0.b;
		return A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$at, keyPath, $elm$json$Json$Decode$string),
			translations);
	});
var $author$project$Enectiva$I18n$t = F2(
	function (translations, key) {
		return A2(
			$elm$core$Result$withDefault,
			key,
			A2(
				$author$project$Enectiva$I18n$tHelp,
				translations,
				$author$project$Enectiva$I18n$keyToKeyPath(key)));
	});
var $author$project$View$tt = F2(
	function (translations, path) {
		return $elm$html$Html$text(
			A2($author$project$Enectiva$I18n$t, translations, path));
	});
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$ExportForm$changeTemplateButtonRow = F2(
	function (_v0, child) {
		var translations = _v0.j;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex justify-between')
				]),
			_List_fromArray(
				[
					child,
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('subdued-button'),
							$elm$html$Html$Events$onClick($author$project$ExportForm$PickAnotherTemplateButtonClicked)
						]),
					_List_fromArray(
						[
							A2($author$project$View$tt, translations, 'export.form.pick_another_template')
						]))
				]));
	});
var $author$project$ExportForm$OneoffPeriodicitySelected = 0;
var $author$project$ExportForm$ScheduledPeriodicitySelected = 1;
var $author$project$ExportForm$continuousExportPeriodicitySelectionView = function (_v0) {
	var translations = _v0.j;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex gap-4')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Events$onClick(0),
						$elm$html$Html$Attributes$class('neutral-button')
					]),
				_List_fromArray(
					[
						A2($author$project$View$tt, translations, 'export.types.export_now')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Events$onClick(1),
						$elm$html$Html$Attributes$class('neutral-button')
					]),
				_List_fromArray(
					[
						A2($author$project$View$tt, translations, 'export.types.scheduled_export')
					]))
			]));
};
var $author$project$ExportForm$DiscreteFormSubmitted = {$: 10};
var $author$project$ExportForm$DiscreteNameChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Spinner$container = $elm$html$Html$Attributes$class('relative');
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$ExportForm$discreteDimensions = function (children) {
	return A2(
		$elm$html$Html$map,
		$author$project$ExportForm$DiscreteFormMsg,
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-2')
				]),
			children));
};
var $author$project$ExportForm$DiscreteEntityShortcutMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$ExportForm$EnergyCheckboxClicked = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$ExportForm$EnergyRadioSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$ExportForm$EntityCheckboxClicked = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Types$energyToLocalizedString = F2(
	function (translations, energy) {
		switch (energy) {
			case 1:
				return A2($author$project$Enectiva$I18n$t, translations, 'energy_el');
			case 2:
				return A2($author$project$Enectiva$I18n$t, translations, 'energy_ga');
			case 3:
				return A2($author$project$Enectiva$I18n$t, translations, 'energy_wa');
			case 4:
				return A2($author$project$Enectiva$I18n$t, translations, 'energy_he');
			case 5:
				return A2($author$project$Enectiva$I18n$t, translations, 'energy_co');
			case 6:
				return A2($author$project$Enectiva$I18n$t, translations, 'energy_hca');
			case 7:
				return A2($author$project$Enectiva$I18n$t, translations, 'energy_lf');
			default:
				return '';
		}
	});
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$SvgIcons$energyIcon = F6(
	function (cls, iconWidth, iconHeight, children, maybeClass, maybeWidth) {
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('energy-icon'),
					$elm$svg$Svg$Attributes$class(cls),
					$elm$svg$Svg$Attributes$class(
					A2($elm$core$Maybe$withDefault, '', maybeClass)),
					$elm$svg$Svg$Attributes$viewBox(
					'0 0 ' + ($elm$core$String$fromFloat(iconWidth) + (' ' + $elm$core$String$fromFloat(iconHeight)))),
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromFloat(
						A2($elm$core$Maybe$withDefault, iconWidth, maybeWidth))),
					$elm$svg$Svg$Attributes$height(
					$elm$core$String$fromFloat(
						A2($elm$core$Maybe$withDefault, iconHeight, maybeWidth)))
				]),
			children);
	});
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $author$project$SvgIcons$co = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	21.75,
	23.5,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12.037,23H9.67v-2.445l-1.621,1.541l-1.628-1.712l3.249-3.085v-3.506l-3.002,1.734l-1.056,4.39l-2.296-0.556l0.53-2.207 l-2.137,1.234l-1.185-2.052l2.117-1.22l-2.143-0.635l0.668-2.265l4.296,1.271l3.045-1.758L5.496,9.991l-4.33,1.281L0.498,9.007 l2.178-0.644L0.537,7.127l1.185-2.05l2.117,1.224L3.316,4.126l2.296-0.553l1.047,4.356L9.67,9.667V6.18L6.421,3.095l1.628-1.71 L9.67,2.924V0.5h2.367v2.449l1.646-1.564l1.629,1.71l-3.275,3.11v3.488l3.055-1.764l1.047-4.356l2.295,0.553l-0.521,2.175 l2.098-1.213l1.184,2.051l-2.118,1.224l2.177,0.644l-0.668,2.265l-4.33-1.281l-3.011,1.738l3.045,1.757l4.296-1.269l0.668,2.263 l-2.145,0.636l2.1,1.211l-1.184,2.051l-2.119-1.226l0.529,2.209l-2.295,0.556l-1.057-4.39l-3.045-1.76v3.506l3.275,3.11l-1.629,1.71 l-1.646-1.564V23z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$el = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	14.87,
	24,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('m 4.973,1.9999455 c -0.36,0 -0.678,0.225 -0.783,0.555 L 0.537,12.767946 c -0.133,0.416 0.109,0.855 0.543,0.982 0.078,0.023 0.16,0.036 0.241,0.036 h 2.767 l -0.752,9.366 c -0.034,0.436 0.303,0.812 0.755,0.846 0.291,0.02 0.571,-0.107 0.738,-0.339 l 9.397,-12.571 c 0.258,-0.357 0.159,-0.847 -0.211,-1.0930004 -0.143,-0.089 -0.301,-0.139 -0.467,-0.139 H 9.666 l 3.881,-6.7200001 c 0.203,-0.388 0.039,-0.859 -0.367,-1.055 -0.114,-0.053 -0.239,-0.081 -0.368,-0.081 z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$ga = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	17.34,
	23,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M 7.983,0.50455415 C 7.85,0.53055415 7.746,0.63555416 7.729,0.76955416 6.952,5.2625542 5.221,7.1065542 3.611,8.7925542 2.003,10.476554 0.499,12.045554 0.499,15.651554 c 0,1.74 0.771,3.201 1.924,4.342 1.154,1.138 2.688,1.961 4.263,2.482 0.166,0.054 0.343,-0.038 0.395,-0.205 0.031,-0.098 0.013,-0.205 -0.05,-0.286 -1.541,-1.85 -1.971,-3.185 -1.935,-4.27 0.032,-0.956 0.443,-1.763 0.864,-2.591 0.622,0.5 1.163,0.914 1.453,1.1 0.177,0.111 0.299,0.183 0.383,0.226 0.084,0.042 0.158,0.069 0.158,0.069 0.09,0.025 0.187,0.012 0.264,-0.041 0,0 0.627,-0.432 1.13,-1.382 0.421,-0.798 0.749,-2.007 0.657,-3.624 2.023,2.204 2.773,4.091 2.75,5.683 -0.03,2.084 -1.282,3.749 -2.418,4.792 -0.131,0.11 -0.149,0.31 -0.037,0.441 0.071,0.086 0.182,0.127 0.296,0.106 3.244,-0.455 6.245,-3.308 6.245,-6.902 0,-2.544 -0.439,-4.794 -1.74,-7.1539998 -1.299,-2.361 -3.449,-4.825 -6.854,-7.85500004 -0.071,-0.064 -0.169,-0.092 -0.264,-0.078 z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$hca = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	20.77,
	21,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M5.483,2.175C5.26,1.746,5.036,1.439,4.634,0.947C4.356,0.578,3.906,0.453,3.451,0.516c-0.677,0.183-1.067,0.86-0.958,1.597 l0.112,0.555c0.059,0.184,0.169,0.49,0.225,0.799c0.059,0.307,0.112,0.553,0.171,0.86C3.058,4.88,3.058,5.433,2.942,5.988 C2.83,6.54,2.721,7.032,2.437,7.583L1.535,9.674c-0.285,0.737-0.567,1.536-0.793,2.457c-0.168,0.923-0.281,1.905-0.225,2.829 c0.113,1.964,0.959,3.686,1.976,4.978c0.337,0.43,0.903,0.614,1.414,0.43c0.675-0.246,1.012-1.045,0.787-1.844v-0.063 c-0.45-1.351-0.734-2.518-0.619-3.626c0.059-1.106,0.396-2.211,0.961-3.563C5.26,10.596,5.6,9.919,5.825,9.18 c0.278-0.798,0.563-1.843,0.563-2.825c0.058-0.983-0.114-1.967-0.394-2.889C5.878,3.037,5.709,2.605,5.483,2.175z M12.437,2.175 c-0.229-0.43-0.452-0.736-0.848-1.229c-0.285-0.308-0.732-0.494-1.187-0.369C9.728,0.762,9.332,1.439,9.445,2.175l0.109,0.553 c0.059,0.184,0.173,0.492,0.228,0.8c0.055,0.308,0.109,0.554,0.168,0.86c0.058,0.555,0.058,1.105-0.059,1.658 c-0.109,0.555-0.223,1.045-0.501,1.6L8.484,9.735c-0.284,0.737-0.563,1.538-0.79,2.458c-0.173,0.922-0.284,1.844-0.227,2.827 C7.579,16.988,8.425,18.71,9.445,20c0.337,0.431,0.901,0.613,1.412,0.431c0.675-0.247,1.011-1.045,0.785-1.845v-0.062 c-0.448-1.352-0.729-2.52-0.618-3.626c0.059-1.107,0.396-2.214,0.961-3.565c0.223-0.676,0.565-1.352,0.79-2.089 c0.28-0.8,0.565-1.845,0.565-2.828c0.052-0.982-0.111-1.967-0.396-2.888C12.827,3.037,12.665,2.605,12.437,2.175z M19.916,3.528 c-0.175-0.433-0.343-0.86-0.565-1.29c-0.227-0.432-0.453-0.738-0.848-1.231c-0.284-0.367-0.733-0.49-1.186-0.429 c-0.679,0.185-1.076,0.861-0.962,1.598l0.114,0.553c0.057,0.184,0.169,0.492,0.227,0.8c0.056,0.308,0.112,0.554,0.167,0.86 c0.059,0.555,0.059,1.105-0.055,1.658c-0.112,0.555-0.23,1.045-0.509,1.6l-0.904,2.089c-0.282,0.737-0.562,1.538-0.787,2.458 c-0.17,0.922-0.281,1.906-0.226,2.827c0.108,1.968,0.957,3.69,1.973,4.979c0.341,0.431,0.908,0.613,1.414,0.431 c0.679-0.247,1.018-1.045,0.789-1.845v-0.062c-0.452-1.352-0.735-2.52-0.62-3.626c0.053-1.107,0.394-2.214,0.959-3.565 c0.227-0.676,0.564-1.352,0.79-2.089c0.284-0.8,0.566-1.845,0.566-2.828C20.31,5.433,20.199,4.388,19.916,3.528z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$he = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	20.77,
	21,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M5.483,2.175C5.26,1.746,5.036,1.439,4.634,0.947C4.356,0.578,3.906,0.453,3.451,0.516c-0.677,0.183-1.067,0.86-0.958,1.597 l0.112,0.555c0.059,0.184,0.169,0.49,0.225,0.799c0.059,0.307,0.112,0.553,0.171,0.86C3.058,4.88,3.058,5.433,2.942,5.988 C2.83,6.54,2.721,7.032,2.437,7.583L1.535,9.674c-0.285,0.737-0.567,1.536-0.793,2.457c-0.168,0.923-0.281,1.905-0.225,2.829 c0.113,1.964,0.959,3.686,1.976,4.978c0.337,0.43,0.903,0.614,1.414,0.43c0.675-0.246,1.012-1.045,0.787-1.844v-0.063 c-0.45-1.351-0.734-2.518-0.619-3.626c0.059-1.106,0.396-2.211,0.961-3.563C5.26,10.596,5.6,9.919,5.825,9.18 c0.278-0.798,0.563-1.843,0.563-2.825c0.058-0.983-0.114-1.967-0.394-2.889C5.878,3.037,5.709,2.605,5.483,2.175z M12.437,2.175 c-0.229-0.43-0.452-0.736-0.848-1.229c-0.285-0.308-0.732-0.494-1.187-0.369C9.728,0.762,9.332,1.439,9.445,2.175l0.109,0.553 c0.059,0.184,0.173,0.492,0.228,0.8c0.055,0.308,0.109,0.554,0.168,0.86c0.058,0.555,0.058,1.105-0.059,1.658 c-0.109,0.555-0.223,1.045-0.501,1.6L8.484,9.735c-0.284,0.737-0.563,1.538-0.79,2.458c-0.173,0.922-0.284,1.844-0.227,2.827 C7.579,16.988,8.425,18.71,9.445,20c0.337,0.431,0.901,0.613,1.412,0.431c0.675-0.247,1.011-1.045,0.785-1.845v-0.062 c-0.448-1.352-0.729-2.52-0.618-3.626c0.059-1.107,0.396-2.214,0.961-3.565c0.223-0.676,0.565-1.352,0.79-2.089 c0.28-0.8,0.565-1.845,0.565-2.828c0.052-0.982-0.111-1.967-0.396-2.888C12.827,3.037,12.665,2.605,12.437,2.175z M19.916,3.528 c-0.175-0.433-0.343-0.86-0.565-1.29c-0.227-0.432-0.453-0.738-0.848-1.231c-0.284-0.367-0.733-0.49-1.186-0.429 c-0.679,0.185-1.076,0.861-0.962,1.598l0.114,0.553c0.057,0.184,0.169,0.492,0.227,0.8c0.056,0.308,0.112,0.554,0.167,0.86 c0.059,0.555,0.059,1.105-0.055,1.658c-0.112,0.555-0.23,1.045-0.509,1.6l-0.904,2.089c-0.282,0.737-0.562,1.538-0.787,2.458 c-0.17,0.922-0.281,1.906-0.226,2.827c0.108,1.968,0.957,3.69,1.973,4.979c0.341,0.431,0.908,0.613,1.414,0.431 c0.679-0.247,1.018-1.045,0.789-1.845v-0.062c-0.452-1.352-0.735-2.52-0.62-3.626c0.053-1.107,0.394-2.214,0.959-3.565 c0.227-0.676,0.564-1.352,0.79-2.089c0.284-0.8,0.566-1.845,0.566-2.828C20.31,5.433,20.199,4.388,19.916,3.528z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$lf = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	23.93,
	22.5,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M3.527,7.357c0,0,2.992,3.304,2.992,4.888c0,1.582-1.34,2.867-2.992,2.867c-1.653,0-2.993-1.283-2.993-2.867 C0.535,10.662,3.527,7.357,3.527,7.357z M23.429,21.12L22.6,19.012c0.231-0.179,0.33-0.48,0.214-0.76l-3.292-7.833l0.604-0.739 c0.127-0.145,0.18-0.341,0.143-0.536c-0.038-0.196-0.159-0.362-0.325-0.454l-7.321-4.248c-0.252-0.144-0.582-0.11-0.804,0.066 l-1.563-1.184c-0.074-0.058-0.162-0.1-0.267-0.126L2.816,1.52C2.443,1.424,2.031,1.676,1.963,2.027L1.589,3.726 C1.51,4.075,1.743,4.429,2.106,4.514l5.898,1.375C8.1,5.958,8.465,6.237,8.929,6.591c0.149,0.115,0.288,0.22,0.422,0.323 C9.208,7.167,9.237,7.486,9.459,7.699l0.438,0.418L12,19.264c0.194,1.155,1.308,2.061,2.537,2.061h0.03 c0.367,0,0.726-0.073,1.067-0.219l2.699-1.158l0.039,0.109c0.088,0.266,0.351,0.45,0.647,0.458l0.797,2.028 C19.906,22.813,20.181,23,20.481,23c0.102,0,0.198-0.021,0.281-0.06l2.296-0.989C23.388,21.811,23.55,21.446,23.429,21.12z M15.396,18.36c-0.227,0.094-0.486-0.05-0.524-0.28l-1.02-5.179c0,0-0.104-0.496,0.358-0.602c0.463-0.104,1.037-0.233,1.037-0.233 l2.003,5.561L15.396,18.36z')
				]),
			_List_Nil)
		]));
var $author$project$Enectiva$View$nothing = $elm$html$Html$text('');
var $author$project$SvgIcons$wa = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	16.3,
	22.52,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M8.476,1.155c-0.15-0.209-0.501-0.209-0.651,0L6.007,3.656C4.715,5.439,0.5,11.511,0.5,14.869 c0,4.221,3.435,7.65,7.649,7.65c4.219,0,7.649-3.433,7.649-7.65c0-3.358-4.22-9.432-5.51-11.213L8.476,1.155z')
				]),
			_List_Nil)
		]));
var $author$project$Types$energyIconWithOpts = F3(
	function (_class, size, energy) {
		switch (energy) {
			case 1:
				return A2($author$project$SvgIcons$el, _class, size);
			case 2:
				return A2($author$project$SvgIcons$ga, _class, size);
			case 3:
				return A2($author$project$SvgIcons$wa, _class, size);
			case 4:
				return A2($author$project$SvgIcons$he, _class, size);
			case 5:
				return A2($author$project$SvgIcons$co, _class, size);
			case 6:
				return A2($author$project$SvgIcons$hca, _class, size);
			case 7:
				return A2($author$project$SvgIcons$lf, _class, size);
			default:
				return $author$project$Enectiva$View$nothing;
		}
	});
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$ExportForm$energyIcon = F2(
	function (checked, energy) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pr-1 fill-current')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Types$energyIconWithOpts,
					$elm$core$Maybe$Just(
						checked ? 'text-blue-600' : 'text-blue-200'),
					$elm$core$Maybe$Nothing,
					energy)
				]));
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $elm$html$Html$label = _VirtualDom_node('label');
var $author$project$ExportForm$picker = $elm$html$Html$label(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex flex-items items-center gap-1'),
			$elm$html$Html$Attributes$class('cursor-pointer'),
			$elm$html$Html$Attributes$class('group'),
			$elm$html$Html$Attributes$class('rounded px-2 py-1'),
			$elm$html$Html$Attributes$class('transition-colors duration-75'),
			$elm$html$Html$Attributes$class('border-transparent border border-solid focus-within:border-blue-500 hover:border-blue-500')
		]));
var $author$project$ExportForm$labeledCheckboxHelp = F4(
	function (inputClass, msg, checked, children) {
		return $author$project$ExportForm$picker(
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$class(inputClass),
							$elm$html$Html$Attributes$checked(checked),
							$elm$html$Html$Events$onCheck(msg)
						]),
					_List_Nil),
				children));
	});
var $author$project$ExportForm$labeledCheckboxWithEnergyIcon = F4(
	function (msg, checked, energy, children) {
		return A4(
			$author$project$ExportForm$labeledCheckboxHelp,
			'w-0 h-0 overflow-hidden',
			msg,
			checked,
			A2(
				$elm$core$List$cons,
				A2($author$project$ExportForm$energyIcon, checked, energy),
				children));
	});
var $author$project$ExportForm$energyCheckbox = F4(
	function (_v0, msg, selectedEnergies, energy) {
		var translations = _v0.j;
		return A4(
			$author$project$ExportForm$labeledCheckboxWithEnergyIcon,
			msg(energy),
			A2($elm$core$List$member, energy, selectedEnergies),
			energy,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block relative top-0.5')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Types$energyToLocalizedString, translations, energy))
						]))
				]));
	});
var $author$project$ExportForm$labeledRadioHelp = F4(
	function (inputClass, msg, checked, children) {
		return $author$project$ExportForm$picker(
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$class(inputClass),
							$elm$html$Html$Attributes$checked(checked),
							$elm$html$Html$Events$onClick(msg)
						]),
					_List_Nil),
				children));
	});
var $author$project$ExportForm$labeledRadioWithEnergyIcon = F4(
	function (msg, checked, energy, children) {
		return A4(
			$author$project$ExportForm$labeledRadioHelp,
			'w-0 h-0 overflow-hidden',
			msg,
			checked,
			A2(
				$elm$core$List$cons,
				A2($author$project$ExportForm$energyIcon, checked, energy),
				children));
	});
var $author$project$ExportForm$energyRadio = F4(
	function (_v0, msg, selectedEnergies, energy) {
		var translations = _v0.j;
		return A4(
			$author$project$ExportForm$labeledRadioWithEnergyIcon,
			msg(energy),
			A2($elm$core$List$member, energy, selectedEnergies),
			energy,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline-block')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Types$energyToLocalizedString, translations, energy))
						]))
				]));
	});
var $author$project$ExportForm$labeledCheckbox = $author$project$ExportForm$labeledCheckboxHelp('focus:outline-none');
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$ExportForm$entityCheckbox = F3(
	function (msg, selectedEntityIds, entity) {
		return A3(
			$author$project$ExportForm$labeledCheckbox,
			msg(entity.f5),
			A2($elm$core$Set$member, entity.f5, selectedEntityIds),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline-block break-all')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(entity.gv)
						]))
				]));
	});
var $author$project$ExportForm$SelectAllButtonClicked = {$: 0};
var $author$project$ExportForm$SelectNoneButtonClicked = {$: 1};
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$ExportForm$shortcutButton = F2(
	function (txt, msg) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Events$onClick(msg),
					$elm$html$Html$Attributes$class('p-1 hover:underline focus:underline subdued-button')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(txt)
				]));
	});
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$ExportForm$entityShortcutButtons = function (context) {
	var translations = context.j;
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex gap-2 items-center')
			]),
		A2(
			$elm$core$List$map,
			function (_v0) {
				var txt = _v0.a;
				var msg = _v0.b;
				return A2(
					$elm$html$Html$li,
					_List_Nil,
					$elm$core$List$singleton(
						A2($author$project$ExportForm$shortcutButton, txt, msg)));
			},
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2($author$project$Enectiva$I18n$t, translations, 'multiselect.all'),
					$author$project$ExportForm$SelectAllButtonClicked),
					_Utils_Tuple2(
					A2($author$project$Enectiva$I18n$t, translations, 'multiselect.none'),
					$author$project$ExportForm$SelectNoneButtonClicked)
				])));
};
var $elm$html$Html$fieldset = _VirtualDom_node('fieldset');
var $elm$html$Html$legend = _VirtualDom_node('legend');
var $author$project$ExportForm$MeasureCheckboxClicked = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$ExportForm$MeasureRadioSelected = function (a) {
	return {$: 7, a: a};
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$ExportForm$measureCheckbox = F4(
	function (_v0, msg, selectedMeasures, _v1) {
		var translations = _v0.j;
		var measure = _v1.a;
		var child = _v1.b;
		return A3(
			$author$project$ExportForm$labeledCheckbox,
			msg(measure),
			A2($elm$core$List$member, measure, selectedMeasures),
			_List_fromArray(
				[
					A2(
					$author$project$View$tt,
					translations,
					'export.measures.' + $author$project$Types$measureToString(measure)),
					child
				]));
	});
var $author$project$ExportForm$labeledRadio = $author$project$ExportForm$labeledRadioHelp('focus:outline-none');
var $author$project$ExportForm$measureRadio = F4(
	function (_v0, msg, selectedMeasures, _v1) {
		var translations = _v0.j;
		var measure = _v1.a;
		var child = _v1.b;
		return A3(
			$author$project$ExportForm$labeledRadio,
			msg(measure),
			A2($elm$core$List$member, measure, selectedMeasures),
			_List_fromArray(
				[
					A2(
					$author$project$View$tt,
					translations,
					'export.measures.' + $author$project$Types$measureToString(measure)),
					child
				]));
	});
var $author$project$SvgIcons$questionMark = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('22.5px'),
			$elm$svg$Svg$Attributes$height('22.5px'),
			$elm$svg$Svg$Attributes$viewBox('0 0 22.5 22.5')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M20.559,5.854c-0.962-1.646-2.266-2.951-3.913-3.912C14.999,0.98,13.2,0.5,11.25,0.5c-1.951,0-3.749,0.48-5.396,1.441C4.207,2.902,2.903,4.207,1.941,5.854C0.98,7.5,0.5,9.299,0.5,11.25c0,1.95,0.48,3.748,1.441,5.396c0.961,1.646,2.266,2.951,3.912,3.912C7.501,21.519,9.299,22,11.25,22c1.95,0,3.749-0.481,5.396-1.442c1.647-0.961,2.951-2.266,3.912-3.912C21.52,14.998,22,13.2,22,11.25C22,9.299,21.52,7.5,20.559,5.854z M12.83,17.08c0,0.113-0.037,0.207-0.11,0.279c-0.072,0.072-0.164,0.109-0.278,0.109h-2.332c-0.114,0-0.208-0.037-0.279-0.109c-0.073-0.072-0.109-0.166-0.109-0.279v-2.333c0-0.112,0.036-0.205,0.109-0.278c0.071-0.073,0.165-0.109,0.279-0.109h2.332c0.114,0,0.206,0.036,0.278,0.109c0.073,0.073,0.11,0.166,0.11,0.278V17.08z M15.788,9.901c-0.103,0.3-0.215,0.545-0.341,0.735c-0.126,0.189-0.306,0.385-0.54,0.583c-0.234,0.197-0.421,0.339-0.559,0.425c-0.139,0.085-0.337,0.2-0.596,0.347c-0.267,0.152-0.488,0.354-0.662,0.602c-0.173,0.247-0.261,0.446-0.261,0.6c0,0.114-0.036,0.208-0.109,0.28s-0.165,0.108-0.279,0.108h-2.332c-0.114,0-0.208-0.036-0.279-0.108c-0.073-0.072-0.109-0.166-0.109-0.28v-0.437c0-0.543,0.212-1.051,0.638-1.524c0.425-0.475,0.894-0.824,1.403-1.051c0.389-0.178,0.663-0.361,0.825-0.547c0.162-0.187,0.243-0.433,0.243-0.741c0-0.268-0.151-0.506-0.456-0.717C12.07,7.965,11.726,7.86,11.336,7.86c-0.421,0-0.77,0.096-1.045,0.291c-0.267,0.195-0.615,0.567-1.045,1.117C9.174,9.367,9.073,9.415,8.942,9.415c-0.097,0-0.174-0.024-0.23-0.073L7.109,8.128c-0.187-0.146-0.219-0.315-0.098-0.51C8.048,5.893,9.55,5.03,11.518,5.03c0.704,0,1.394,0.165,2.066,0.497c0.672,0.333,1.232,0.802,1.682,1.409c0.449,0.608,0.674,1.268,0.674,1.981C15.939,9.273,15.889,9.601,15.788,9.901z')
				]),
			_List_Nil)
		]));
var $author$project$ExportForm$measuresFieldset = F3(
	function (context, attrs, measuresDimensionIncluded) {
		var translations = context.j;
		var measureFn = measuresDimensionIncluded ? A3($author$project$ExportForm$measureCheckbox, context, $author$project$ExportForm$MeasureCheckboxClicked, attrs.az) : A3($author$project$ExportForm$measureRadio, context, $author$project$ExportForm$MeasureRadioSelected, attrs.az);
		var consumptionHelp = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('help bg-transparent text-grey-400'),
					$elm$html$Html$Attributes$class('hover:text-grey-600 hover:bg-transparent'),
					$elm$html$Html$Attributes$class('focus:text-grey-600 focus:bg-transparent'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-help',
					A2($author$project$Enectiva$I18n$t, translations, 'deltas_explanation'))
				]),
			_List_fromArray(
				[$author$project$SvgIcons$questionMark]));
		var measuresWithHelp = _List_fromArray(
			[
				_Utils_Tuple2(0, consumptionHelp),
				_Utils_Tuple2(1, $author$project$Enectiva$View$nothing)
			]);
		return A2(
			$elm$html$Html$fieldset,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$legend,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$View$tt, translations, 'export.template.dimension.measures')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('grid gap-1 grid-consumption-sources w-full')
						]),
					A2($elm$core$List$map, measureFn, measuresWithHelp))
				]));
	});
var $author$project$ExportForm$discreteEntitiesDimensions = F4(
	function (context, attrs, measuresDimensionIncluded, energiesDimensionIncluded) {
		var translations = context.j;
		var energyFn = energiesDimensionIncluded ? A3($author$project$ExportForm$energyCheckbox, context, $author$project$ExportForm$EnergyCheckboxClicked, attrs.M) : A3($author$project$ExportForm$energyRadio, context, $author$project$ExportForm$EnergyRadioSelected, attrs.M);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$fieldset,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$ExportForm$DiscreteEntityShortcutMsg,
						A2(
							$elm$html$Html$legend,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex justify-between items-center gap-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('inline-block fieldset')
										]),
									_List_fromArray(
										[
											A2($author$project$View$tt, translations, 'export.form.entities_to_export')
										])),
									$author$project$ExportForm$entityShortcutButtons(context)
								]))),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('grid gap-1 grid-consumption-sources w-full')
							]),
						A2(
							$elm$core$List$map,
							A2($author$project$ExportForm$entityCheckbox, $author$project$ExportForm$EntityCheckboxClicked, attrs.aq),
							context.bA))
					])),
				A2(
				$elm$html$Html$fieldset,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$legend,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$View$tt, translations, 'export.form.energies_to_export')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('grid gap-1 grid-consumption-sources w-full')
							]),
						A2($elm$core$List$map, energyFn, context.M))
					])),
				A3($author$project$ExportForm$measuresFieldset, context, attrs, measuresDimensionIncluded)
			]);
	});
var $author$project$ExportForm$DiscreteMeterShortcutMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$ExportForm$MeterCheckboxClicked = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$ExportForm$meterCheckbox = F3(
	function (msg, selectedMeterIds, meter) {
		return A4(
			$author$project$ExportForm$labeledCheckboxWithEnergyIcon,
			msg(meter.f5),
			A2($elm$core$Set$member, meter.f5, selectedMeterIds),
			meter.cH,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline-block break-all')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(meter.gv)
						]))
				]));
	});
var $author$project$ExportForm$meterGrid = F4(
	function (context, filter, msg, selectedMeterIds) {
		var translations = context.j;
		var filteredMeters = A2($elm$core$List$filter, filter, context.a$);
		return $elm$core$List$isEmpty(filteredMeters) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-red-600 error items-center')
				]),
			_List_fromArray(
				[
					A2($author$project$View$tt, translations, 'export.form.no_meters_to_export')
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid gap-1 grid-consumption-sources w-full')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$ExportForm$meterCheckbox, msg, selectedMeterIds),
				filteredMeters));
	});
var $author$project$ExportForm$SelectOneEnergyButtonClicked = function (a) {
	return {$: 2, a: a};
};
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, _List_Nil, list, _List_Nil);
};
var $author$project$ExportForm$meterShortcutButtons = F2(
	function (context, filter) {
		var translations = context.j;
		var energies = A2(
			$elm$core$List$map,
			function (e) {
				return _Utils_Tuple2(
					A2($author$project$Types$energyToLocalizedString, translations, e),
					$author$project$ExportForm$SelectOneEnergyButtonClicked(e));
			},
			$elm_community$list_extra$List$Extra$unique(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.cH;
					},
					A2($elm$core$List$filter, filter, context.a$))));
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex gap-2 items-center')
				]),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var txt = _v0.a;
					var msg = _v0.b;
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						$elm$core$List$singleton(
							A2($author$project$ExportForm$shortcutButton, txt, msg)));
				},
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						A2($author$project$Enectiva$I18n$t, translations, 'multiselect.all'),
						$author$project$ExportForm$SelectAllButtonClicked),
					_Utils_ap(
						energies,
						_List_fromArray(
							[
								_Utils_Tuple2(
								A2($author$project$Enectiva$I18n$t, translations, 'multiselect.none'),
								$author$project$ExportForm$SelectNoneButtonClicked)
							])))));
	});
var $author$project$ExportForm$meterGridLegend = F2(
	function (context, filter) {
		var translations = context.j;
		return A2(
			$elm$html$Html$legend,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex justify-between items-center gap-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline-block')
						]),
					_List_fromArray(
						[
							A2($author$project$View$tt, translations, 'export.form.meters_to_export')
						])),
					A2($author$project$ExportForm$meterShortcutButtons, context, filter)
				]));
	});
var $author$project$ExportForm$discreteMetersDimensions = F3(
	function (context, attrs, measuresDimensionIncluded) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$fieldset,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$ExportForm$DiscreteMeterShortcutMsg,
						A2(
							$author$project$ExportForm$meterGridLegend,
							context,
							$elm$core$Basics$always(true))),
						A4(
						$author$project$ExportForm$meterGrid,
						context,
						$elm$core$Basics$always(true),
						$author$project$ExportForm$MeterCheckboxClicked,
						attrs.f)
					])),
				A3($author$project$ExportForm$measuresFieldset, context, attrs, measuresDimensionIncluded)
			]);
	});
var $author$project$ExportForm$DiscretePeriodSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$ExportForm$continuousPeriods = _List_fromArray(
	[0, 1, 2]);
var $author$project$ExportForm$discretePeriods = _Utils_ap(
	$author$project$ExportForm$continuousPeriods,
	_List_fromArray(
		[3]));
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$ExportForm$periodOption = F3(
	function (translations, current, period) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$author$project$Types$periodToString(period)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(current, period))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$View$tt,
					translations,
					'export.period_select.' + $author$project$Types$periodToString(period))
				]));
	});
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $author$project$ExportForm$discretePeriodSelect = F3(
	function (_v0, range, period) {
		var translations = _v0.j;
		var periods = $author$project$Enectiva$DateRange$isLongerThanOneDay(range) ? $author$project$ExportForm$discretePeriods : A2($elm_community$list_extra$List$Extra$remove, 0, $author$project$ExportForm$discretePeriods);
		return A2(
			$elm$html$Html$label,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$View$tt, translations, 'activerecord.attributes.export.period')
						])),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('textfield w-24 pr-8'),
							A2(
							$elm$html$Html$Events$on,
							'change',
							A3(
								$elm$core$Basics$composeR,
								$elm$json$Json$Decode$map($author$project$Types$stringToPeriod),
								$elm$json$Json$Decode$map($author$project$ExportForm$DiscretePeriodSelected),
								$elm$html$Html$Events$targetValue))
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$ExportForm$periodOption, translations, period),
						periods))
				]));
	});
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$View$onChange = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue));
};
var $author$project$ExportForm$nameInput = F3(
	function (_v0, msg, name) {
		var translations = _v0.j;
		return A2(
			$elm$html$Html$label,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$View$tt, translations, 'activerecord.attributes.export.name')
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$class('textfield'),
							$elm$html$Html$Attributes$value(name),
							$author$project$View$onChange(msg)
						]),
					_List_Nil)
				]));
	});
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$scaleFrom255 = function (c) {
	return c / 255;
};
var $avh4$elm_color$Color$rgb255 = F3(
	function (r, g, b) {
		return A4(
			$avh4$elm_color$Color$RgbaSpace,
			$avh4$elm_color$Color$scaleFrom255(r),
			$avh4$elm_color$Color$scaleFrom255(g),
			$avh4$elm_color$Color$scaleFrom255(b),
			1.0);
	});
var $author$project$Enectiva$Spinner$colours = {
	d5: 2100,
	dF: A3($avh4$elm_color$Color$rgb255, 0, 90, 171),
	dM: A3($avh4$elm_color$Color$rgb255, 244, 122, 55),
	fo: A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$elm$html$Html$div(_List_Nil))
};
var $author$project$Enectiva$Spinner$cssColorString = F2(
	function (kind, values) {
		return kind + ('(' + (A2($elm$core$String$join, ', ', values) + ')'));
	});
var $avh4$elm_color$Color$toRgba = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return {hH: a, hM: b, ie: g, iU: r};
};
var $author$project$Enectiva$Spinner$colorToCssRgba = function (color) {
	var _v0 = $avh4$elm_color$Color$toRgba(color);
	var red = _v0.iU;
	var green = _v0.ie;
	var blue = _v0.hM;
	var alpha = _v0.hH;
	return A2(
		$author$project$Enectiva$Spinner$cssColorString,
		'rgba',
		_List_fromArray(
			[
				$elm$core$String$fromFloat(red * 255),
				$elm$core$String$fromFloat(green * 255),
				$elm$core$String$fromFloat(blue * 255),
				$elm$core$String$fromFloat(alpha)
			]));
};
var $elm$svg$Svg$style = $elm$svg$Svg$trustedNode('style');
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Enectiva$Spinner$style = function (settings) {
	return A2(
		$elm$svg$Svg$style,
		_List_Nil,
		_List_fromArray(
			[
				$elm$svg$Svg$text(
				'path.spinner-punk{fill:' + ($author$project$Enectiva$Spinner$colorToCssRgba(settings.dM) + ';opacity:0}'))
			]));
};
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');
var $author$project$Enectiva$Spinner$letterE = function (settings) {
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('m19.315,27.286194c0,-7.673 -4.763,-10.848 -9.525,-10.848 -5.557,0 -9.79,4.233 -9.79,9.525 0,6.879 5.027,10.054 9.79,10.054 5.027,0 8.995,-4.498 8.995,-6.615H16.14c0,1.323 -2.911,4.234 -6.35,4.234 -2.911,0 -7.144,-1.588 -7.144,-6.35h16.669m-2.646,-2.382c0,-3.175 -2.646,-6.085 -6.879,-6.085 -3.44,0 -7.144,2.646 -7.144,6.085h14.023'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$fill(
				$author$project$Enectiva$Spinner$colorToCssRgba(settings.dF)),
				$elm$svg$Svg$Attributes$class('e')
			]),
		_List_Nil);
};
var $elm$svg$Svg$animate = $elm$svg$Svg$trustedNode('animate');
var $elm$svg$Svg$Attributes$attributeName = _VirtualDom_attribute('attributeName');
var $elm$svg$Svg$Attributes$begin = _VirtualDom_attribute('begin');
var $elm$svg$Svg$Attributes$dur = _VirtualDom_attribute('dur');
var $elm$svg$Svg$Attributes$keyTimes = _VirtualDom_attribute('keyTimes');
var $elm$svg$Svg$Attributes$repeatCount = _VirtualDom_attribute('repeatCount');
var $elm$svg$Svg$Attributes$values = function (value) {
	return A2(
		_VirtualDom_attribute,
		'values',
		_VirtualDom_noJavaScriptUri(value));
};
var $author$project$Enectiva$Spinner$punk = F4(
	function (settings, index, path, begin) {
		return A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d(path),
					$elm$svg$Svg$Attributes$class('spinner-punk')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$animate,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$attributeName('opacity'),
							$elm$svg$Svg$Attributes$values('0;1;0;0'),
							$elm$svg$Svg$Attributes$keyTimes('0;0.2;0.4;1'),
							$elm$svg$Svg$Attributes$dur(
							$elm$core$String$fromFloat(settings.d5) + 'ms'),
							$elm$svg$Svg$Attributes$repeatCount('indefinite'),
							$elm$svg$Svg$Attributes$begin(begin)
						]),
					_List_Nil)
				]));
	});
var $author$project$Enectiva$Spinner$svgElements = function (settings) {
	return _List_fromArray(
		[
			$author$project$Enectiva$Spinner$letterE(settings),
			A4($author$project$Enectiva$Spinner$punk, settings, 0, 'm2.5 8.6c0 2.4 0 4.9 0 7.3 0.3-0.3 2.2-1.3 2.8-1.3 0-2 0-4 0-6z', '0s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 1, 'm8.5 4.5c0 3.2 0 6.4 0 9.5 1.3-0.1 1.6-0.1 2.8 0 0-3.2 0-6.4 0-9.5z', '0.35s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 2, 'm14.5 0c0 4.9 0 9.7 0 14.6 0.6 0 2.5 1 2.8 1.3 0-5.3 0-10.6 0-15.9z', '0.7s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 5, 'm2.9 36.4c0 2.1 0 4.3 0 6.4h2.7v-5.1c-0.3 0-2.4-1.1-2.7-1.3z', '1.75s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 4, 'm8.6 38.2c0 1.6 0 3 0 4.5h2.7c0-1.6 0-3.1 0-4.5-0.9 0.2-1.8 0.2-2.7 0z', '1.4s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 3, 'm16.9 36.4c-0.3 0.3-2.4 1.3-2.7 1.3 0 1.8 0 3.5 0 5.1h2.7c0-2.2 0-4.4 0-6.4z', '1.05s')
		]);
};
var $author$project$Enectiva$Spinner$full = F2(
	function (settings, show) {
		return show ? settings.fo(
			A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$height('100%'),
						$elm$svg$Svg$Attributes$viewBox('0 0 20 43')
					]),
				A2(
					$elm$core$List$cons,
					$author$project$Enectiva$Spinner$style(settings),
					$author$project$Enectiva$Spinner$svgElements(settings)))) : $elm$svg$Svg$text('');
	});
var $author$project$Enectiva$View$viewIf = F2(
	function (view, condition) {
		return condition ? view(0) : $elm$html$Html$text('');
	});
var $author$project$Spinner$overlay = $author$project$Enectiva$View$viewIf(
	function (_v0) {
		var _default = $author$project$Enectiva$Spinner$colours;
		var opts = _Utils_update(
			_default,
			{
				fo: function (svg) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-white opacity-70 absolute top-0 left-0 w-full h-full z-50'),
								A2($elm$html$Html$Attributes$attribute, 'data-spinner-target', 'overlay')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('absolute left-1/2 top-1/10 h-8/10 max-h-12')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('h-full relative -left-1/2')
											]),
										_List_fromArray(
											[svg]))
									]))
							]));
				}
			});
		return A2($author$project$Enectiva$Spinner$full, opts, true);
	});
var $author$project$ExportForm$DateRangePicked = function (a) {
	return {$: 11, a: a};
};
var $author$project$View$datePickerOpts = {bU: '', b7: $elm$core$Maybe$Nothing, b8: $elm$core$Maybe$Nothing};
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $author$project$SvgIcons$calendar = function (svgClasses) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$x('0px'),
				$elm$svg$Svg$Attributes$y('0px'),
				$elm$svg$Svg$Attributes$width('21px'),
				$elm$svg$Svg$Attributes$height('21.6px'),
				$elm$svg$Svg$Attributes$viewBox('-1.5 1.498 21 21.6'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$class('line-icon -mt-px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M13.111,17.52c-0.199,0-0.361,0.163-0.361,0.363v1.715c0,0.199,0.162,0.361,0.361,0.361H15.3c0.2,0,0.362-0.162,0.362-0.361 v-1.715c0-0.2-0.162-0.363-0.362-0.363H13.111z M7.906,17.52c-0.2,0-0.363,0.163-0.363,0.363v1.715c0,0.199,0.163,0.361,0.363,0.361 h2.188c0.2,0,0.363-0.162,0.363-0.361v-1.715c0-0.2-0.163-0.363-0.363-0.363H7.906z M2.641,17.52c-0.2,0-0.363,0.163-0.363,0.363 v1.715c0,0.199,0.163,0.361,0.363,0.361h2.188c0.2,0,0.363-0.162,0.363-0.361v-1.715c0-0.2-0.163-0.363-0.363-0.363H2.641z M13.111,13.795c-0.199,0-0.361,0.162-0.361,0.361v1.715c0,0.2,0.162,0.363,0.361,0.363H15.3c0.2,0,0.362-0.163,0.362-0.363v-1.715 c0-0.199-0.162-0.361-0.362-0.361H13.111z M7.906,13.795c-0.2,0-0.363,0.162-0.363,0.361v1.715c0,0.2,0.163,0.363,0.363,0.363h2.188 c0.2,0,0.363-0.163,0.363-0.363v-1.715c0-0.199-0.163-0.361-0.363-0.361H7.906z M2.641,13.795c-0.2,0-0.363,0.162-0.363,0.361v1.715 c0,0.2,0.163,0.363,0.363,0.363h2.188c0.2,0,0.363-0.163,0.363-0.363v-1.715c0-0.199-0.163-0.361-0.363-0.361H2.641z M13.111,9.924 c-0.199,0-0.361,0.163-0.361,0.363v1.715c0,0.2,0.162,0.363,0.361,0.363H15.3c0.2,0,0.362-0.163,0.362-0.363v-1.715 c0-0.2-0.162-0.363-0.362-0.363H13.111z M7.906,9.924c-0.2,0-0.363,0.163-0.363,0.363v1.715c0,0.2,0.163,0.363,0.363,0.363h2.188 c0.197,0,0.363-0.166,0.363-0.363v-1.715c0-0.2-0.163-0.363-0.363-0.363H7.906z M2.641,9.924c-0.2,0-0.363,0.163-0.363,0.363v1.715 c0,0.2,0.163,0.363,0.363,0.363h2.188c0.197,0,0.363-0.166,0.363-0.363v-1.715c0-0.2-0.163-0.363-0.363-0.363H2.641z M13.249,2.146 c-0.226,0-0.408,0.183-0.408,0.408v3.016c0,0.224,0.183,0.407,0.408,0.407h1.158c0.225,0,0.407-0.183,0.407-0.407V2.554 c0-0.225-0.183-0.408-0.407-0.408H13.249z M3.597,2.146c-0.225,0-0.408,0.183-0.408,0.408v3.016c0,0.224,0.183,0.407,0.408,0.407 h1.159c0.224,0,0.407-0.183,0.407-0.407V2.554c0-0.225-0.183-0.408-0.407-0.408H3.597z M18.462,4.424h-2.188 c-0.114,0-0.114,0.007-0.114,0.064v0.954c0,1.111-0.69,1.801-1.802,1.801h-1.068c-1.077,0-1.801-0.724-1.801-1.801V4.538 c0-0.099-0.069-0.114-0.111-0.114H6.665c-0.128,0-0.153,0.01-0.153,0.122v0.896c0,1.145-0.656,1.801-1.801,1.801H3.643 c-1.212,0-1.802-0.589-1.802-1.801V4.581c0-0.149-0.156-0.157-0.187-0.157h-2.116c-0.321,0-0.389,0.428-0.389,0.788V22.32 c0.016,0.008,0.032,0.016,0.05,0.024c0.09,0.044,0.212,0.104,0.338,0.104h18.923c0.126,0,0.248-0.06,0.338-0.104 c0.018-0.009,0.034-0.017,0.05-0.024V5.212C18.85,4.853,18.782,4.424,18.462,4.424z M17.654,20.865c0,0.211-0.178,0.389-0.388,0.389 H0.734c-0.214,0-0.388-0.174-0.388-0.389V8.71c0-0.214,0.174-0.388,0.388-0.388h16.532c0.21,0,0.388,0.178,0.388,0.388V20.865z')
					]),
				_List_Nil)
			]));
};
var $author$project$View$dateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $justinmimbs$date$Date$fromIsoString(s);
		if (_v0.$ === 1) {
			var err = _v0.a;
			return $elm$json$Json$Decode$fail(err);
		} else {
			var d = _v0.a;
			return $elm$json$Json$Decode$succeed(d);
		}
	},
	$elm$json$Json$Decode$string);
var $justinmimbs$time_extra$Time$Extra$Parts = F7(
	function (year, month, day, hour, minute, second, millisecond) {
		return {fG: day, ed: hour, ey: millisecond, eA: minute, gs: month, e3: second, hC: year};
	});
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var year = _v0.hC;
		var month = _v0.gs;
		var day = _v0.fG;
		var hour = _v0.ed;
		var minute = _v0.eA;
		var second = _v0.e3;
		var millisecond = _v0.ey;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $author$project$Enectiva$I18n$dateToMidnight = function (date) {
	return A2(
		$justinmimbs$time_extra$Time$Extra$partsToPosix,
		$elm$time$Time$utc,
		A7(
			$justinmimbs$time_extra$Time$Extra$Parts,
			$justinmimbs$date$Date$year(date),
			$justinmimbs$date$Date$month(date),
			$justinmimbs$date$Date$day(date),
			0,
			0,
			0,
			0));
};
var $author$project$Enectiva$I18n$defaultDateFormatName = 'date.formats.date_js';
var $author$project$Enectiva$I18n$fourDigitYear = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$fromPosix(zone),
		A2($elm$core$Basics$composeR, $justinmimbs$date$Date$year, $elm$core$String$fromInt));
};
var $author$project$Enectiva$I18n$oneDigitMonth = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$fromPosix(zone),
		A2($elm$core$Basics$composeR, $justinmimbs$date$Date$monthNumber, $elm$core$String$fromInt));
};
var $author$project$Enectiva$I18n$monthAbbr = F2(
	function (translations, zone) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Enectiva$I18n$oneDigitMonth(zone),
			function (number) {
				return A2($author$project$Enectiva$I18n$t, translations, 'date.abbr_month_names.' + number);
			});
	});
var $author$project$Enectiva$I18n$oneDigit24Hour = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$time$Time$toHour(zone),
		$elm$core$String$fromInt);
};
var $author$project$Enectiva$I18n$oneDigitDay = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$fromPosix(zone),
		A2($elm$core$Basics$composeR, $justinmimbs$date$Date$day, $elm$core$String$fromInt));
};
var $author$project$Enectiva$I18n$twoDigits = A2($elm$core$String$padLeft, 2, '0');
var $author$project$Enectiva$I18n$twoDigit24Hour = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$time$Time$toHour(zone),
		A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Enectiva$I18n$twoDigits));
};
var $author$project$Enectiva$I18n$twoDigitDay = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Enectiva$I18n$oneDigitDay(zone),
		$author$project$Enectiva$I18n$twoDigits);
};
var $author$project$Enectiva$I18n$twoDigitMinute = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$time$Time$toMinute(zone),
		A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Enectiva$I18n$twoDigits));
};
var $author$project$Enectiva$I18n$twoDigitMonth = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Enectiva$I18n$oneDigitMonth(zone),
		$author$project$Enectiva$I18n$twoDigits);
};
var $author$project$Enectiva$I18n$twoDigitSecond = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$time$Time$toSecond(zone),
		A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Enectiva$I18n$twoDigits));
};
var $author$project$Enectiva$I18n$twoDigitYear = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Enectiva$I18n$fourDigitYear(zone),
		$elm$core$String$right(2));
};
var $author$project$Enectiva$I18n$dateReplacers = F2(
	function (translations, zone) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'yyyy',
				$author$project$Enectiva$I18n$fourDigitYear(zone)),
				_Utils_Tuple2(
				'yy',
				$author$project$Enectiva$I18n$twoDigitYear(zone)),
				_Utils_Tuple2(
				'MMM',
				A2($author$project$Enectiva$I18n$monthAbbr, translations, zone)),
				_Utils_Tuple2(
				'MM',
				$author$project$Enectiva$I18n$twoDigitMonth(zone)),
				_Utils_Tuple2(
				'M',
				$author$project$Enectiva$I18n$oneDigitMonth(zone)),
				_Utils_Tuple2(
				'dd',
				$author$project$Enectiva$I18n$twoDigitDay(zone)),
				_Utils_Tuple2(
				'd',
				$author$project$Enectiva$I18n$oneDigitDay(zone)),
				_Utils_Tuple2(
				'HH',
				$author$project$Enectiva$I18n$twoDigit24Hour(zone)),
				_Utils_Tuple2(
				'H',
				$author$project$Enectiva$I18n$oneDigit24Hour(zone)),
				_Utils_Tuple2(
				'mm',
				$author$project$Enectiva$I18n$twoDigitMinute(zone)),
				_Utils_Tuple2(
				'ss',
				$author$project$Enectiva$I18n$twoDigitSecond(zone))
			]);
	});
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $elm$regex$Regex$never = _Regex_never;
var $elm_community$list_extra$List$Extra$findMap = F2(
	function (f, list) {
		findMap:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var a = list.a;
				var tail = list.b;
				var _v1 = f(a);
				if (!_v1.$) {
					var b = _v1.a;
					return $elm$core$Maybe$Just(b);
				} else {
					var $temp$f = f,
						$temp$list = tail;
					f = $temp$f;
					list = $temp$list;
					continue findMap;
				}
			}
		}
	});
var $author$project$Enectiva$I18n$replacePlaceholders = F3(
	function (replacers, time, placeholder) {
		return function (replacer) {
			if (!replacer.$) {
				var r = replacer.a;
				return r(time);
			} else {
				return '';
			}
		}(
			A2(
				$elm_community$list_extra$List$Extra$findMap,
				function (_v0) {
					var p = _v0.a;
					var dr = _v0.b;
					return _Utils_eq(p, placeholder) ? $elm$core$Maybe$Just(dr) : $elm$core$Maybe$Nothing;
				},
				replacers));
	});
var $author$project$Enectiva$I18n$formatDateTimeCustomPattern = F4(
	function (pattern, translations, zone, time) {
		var replacers = A2($author$project$Enectiva$I18n$dateReplacers, translations, zone);
		var placeholdersRegex = function (s) {
			return '(' + (s + ')');
		}(
			A2(
				$elm$core$String$join,
				'|',
				A2($elm$core$List$map, $elm$core$Tuple$first, replacers)));
		var primaryRegex = A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('(.*?)' + placeholdersRegex));
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, matches) {
						var _v0 = matches.hd;
						_v0$2:
						while (true) {
							if (_v0.b) {
								if (_v0.a.$ === 1) {
									if ((_v0.b.b && (!_v0.b.a.$)) && (!_v0.b.b.b)) {
										var _v1 = _v0.a;
										var _v2 = _v0.b;
										var placeholder = _v2.a.a;
										return A3($author$project$Enectiva$I18n$replacePlaceholders, replacers, time, placeholder);
									} else {
										break _v0$2;
									}
								} else {
									if ((_v0.b.b && (!_v0.b.a.$)) && (!_v0.b.b.b)) {
										var literal = _v0.a.a;
										var _v3 = _v0.b;
										var placeholder = _v3.a.a;
										return _Utils_ap(
											literal,
											A3($author$project$Enectiva$I18n$replacePlaceholders, replacers, time, placeholder));
									} else {
										break _v0$2;
									}
								}
							} else {
								break _v0$2;
							}
						}
						return matches.iq;
					}),
				A2($elm$regex$Regex$find, primaryRegex, pattern)));
	});
var $author$project$Enectiva$I18n$formatDateTimePreDefinedTemplate = F2(
	function (formatKey, translations) {
		return A2(
			$author$project$Enectiva$I18n$formatDateTimeCustomPattern,
			A2($author$project$Enectiva$I18n$t, translations, formatKey),
			translations);
	});
var $author$project$Enectiva$I18n$formatDate = F2(
	function (translations, date) {
		return A4(
			$author$project$Enectiva$I18n$formatDateTimePreDefinedTemplate,
			$author$project$Enectiva$I18n$defaultDateFormatName,
			translations,
			$elm$time$Time$utc,
			$author$project$Enectiva$I18n$dateToMidnight(date));
	});
var $author$project$Enectiva$I18n$formatDateRange = F2(
	function (translations, _v0) {
		var from = _v0.a;
		var to = _v0.b;
		return A2($author$project$Enectiva$I18n$formatDate, translations, from) + (' - ' + A2($author$project$Enectiva$I18n$formatDate, translations, to));
	});
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Enectiva$I18n$locale = function (_v0) {
	var l = _v0.a;
	return l;
};
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$View$dateRangePickerInput = F4(
	function (translations, opts, msg, range) {
		var formattedRange = A2($author$project$Enectiva$I18n$formatDateRange, translations, range);
		var attrs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$justinmimbs$date$Date$toIsoString,
						$elm$html$Html$Attributes$attribute('data-datepicker-min-value')),
					opts.b8),
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$justinmimbs$date$Date$toIsoString,
						$elm$html$Html$Attributes$attribute('data-datepicker-max-value')),
					opts.b7)
				]));
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				attrs,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inline-flex items-center justify-between w-52 bg-white'),
						$elm$html$Html$Attributes$class('textfield p-0 pr-1 focus-within:border-grey-800'),
						$elm$html$Html$Attributes$class('relative'),
						$elm$html$Html$Attributes$class(opts.bU),
						A2($elm$html$Html$Attributes$attribute, 'data-controller', 'datepicker'),
						A2($elm$html$Html$Attributes$attribute, 'data-datepicker-current-class', 'current'),
						A2($elm$html$Html$Attributes$attribute, 'data-datepicker-range-value', 'true'),
						A2(
						$elm$html$Html$Attributes$attribute,
						'data-datepicker-date-format-value',
						A2($author$project$Enectiva$I18n$t, translations, 'date.formats.picker_js')),
						A2(
						$elm$html$Html$Attributes$attribute,
						'data-datepicker-locale-value',
						$author$project$Enectiva$I18n$locale(translations)),
						$elm$html$Html$Attributes$title(formattedRange),
						A2(
						$elm$html$Html$Events$on,
						'datepicker:date-range-picked',
						A2(
							$elm$json$Json$Decode$map,
							msg,
							A2(
								$elm$json$Json$Decode$field,
								'detail',
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'to',
									$author$project$View$dateDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'from',
										$author$project$View$dateDecoder,
										$elm$json$Json$Decode$succeed($elm$core$Tuple$pair))))))
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$class('textfield border-none outline-none min-w-0 flex-1 box-content m-0'),
							$elm$html$Html$Attributes$value(formattedRange),
							$elm$html$Html$Attributes$id('datepicker-input'),
							A2($elm$html$Html$Attributes$attribute, 'data-datepicker-target', 'input')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							A2($elm$html$Html$Attributes$attribute, 'data-datepicker-target', 'toggle'),
							$elm$html$Html$Attributes$class('w-5 h-5 shrink-0 box-content')
						]),
					_List_fromArray(
						[
							$author$project$SvgIcons$calendar('line-icon')
						]))
				]));
	});
var $author$project$ExportForm$rangeInput = F2(
	function (_v0, range) {
		var translations = _v0.j;
		return A2(
			$elm$html$Html$label,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$View$tt, translations, 'activerecord.attributes.export.time_range')
						])),
					A4($author$project$View$dateRangePickerInput, translations, $author$project$View$datePickerOpts, $author$project$ExportForm$DateRangePicked, range)
				]));
	});
var $author$project$ServerErrors$viewAllFields = F2(
	function (fn, errors) {
		if ((!errors.$) && (errors.a.$ === 1)) {
			var dict = errors.a.a;
			return A2(
				$elm$core$List$concatMap,
				function (_v1) {
					var f = _v1.a;
					var errs = _v1.b;
					return A2(fn, f, errs);
				},
				$elm$core$Dict$toList(dict));
		} else {
			return _List_Nil;
		}
	});
var $author$project$ServerErrors$viewGeneral = F2(
	function (fn, errors) {
		if ((!errors.$) && (!errors.a.$)) {
			var reason = errors.a.a;
			return $elm$core$Maybe$Just(
				fn(reason));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$ExportForm$serverErrorsView = F2(
	function (_v0, submitRequest) {
		var translations = _v0.j;
		if (submitRequest.$ === 2) {
			var errors = submitRequest.a;
			var individualErrors = A2(
				$author$project$ServerErrors$viewAllFields,
				F2(
					function (f, errs) {
						return A2(
							$elm$core$List$map,
							function (e) {
								return (f === '') ? e : (A2($author$project$Enectiva$I18n$t, translations, 'activerecord.attributes.export.' + f) + (' ' + e));
							},
							errs);
					}),
				$elm$core$Maybe$Just(errors));
			var generalError = A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				$elm$core$List$singleton(
					A2(
						$author$project$ServerErrors$viewGeneral,
						$elm$core$Basics$identity,
						$elm$core$Maybe$Just(errors))));
			var allErrors = _Utils_ap(generalError, individualErrors);
			if (!allErrors.b) {
				return $author$project$Enectiva$View$nothing;
			} else {
				var errs = allErrors;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-red-600 error')
						]),
					$elm$core$List$singleton(
						A2(
							$elm$html$Html$ul,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$html$Html$text,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$List$singleton,
										$elm$html$Html$li(_List_Nil))),
								errs))));
			}
		} else {
			return $author$project$Enectiva$View$nothing;
		}
	});
var $author$project$ExportForm$submitButton = F4(
	function (_v0, disabled, key, title) {
		var translations = _v0.j;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('submit'),
							$elm$html$Html$Attributes$class('submit-button'),
							$elm$html$Html$Attributes$disabled(disabled),
							$elm$html$Html$Attributes$title(title)
						]),
					_List_fromArray(
						[
							A2($author$project$View$tt, translations, key)
						]))
				]));
	});
var $author$project$ExportForm$discreteExportFormView = F4(
	function (context, template, attrs, submitRequest) {
		var translations = context.j;
		var disabled = $elm$core$Set$isEmpty(attrs.f) && $elm$core$Set$isEmpty(attrs.aq);
		var tooltip = disabled ? A2($author$project$Enectiva$I18n$t, translations, 'export.form.disabled_meter_button_tooltip') : '';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[$author$project$Spinner$container]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-2 bg-transparent p-0'),
							$elm$html$Html$Events$onSubmit(
							$author$project$ExportForm$DiscreteFormMsg($author$project$ExportForm$DiscreteFormSubmitted)),
							$elm$html$Html$Attributes$disabled(
							_Utils_eq(submitRequest, $krisajenkins$remotedata$RemoteData$Loading)),
							$elm$html$Html$Attributes$title(tooltip)
						]),
					_List_fromArray(
						[
							A2($author$project$ExportForm$serverErrorsView, context, submitRequest),
							A2(
							$author$project$ExportForm$changeTemplateButtonRow,
							context,
							A3(
								$author$project$ExportForm$nameInput,
								context,
								A2($elm$core$Basics$composeR, $author$project$ExportForm$DiscreteNameChanged, $author$project$ExportForm$DiscreteFormMsg),
								attrs.gv)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex gap-4')
								]),
							_List_fromArray(
								[
									A2($author$project$ExportForm$rangeInput, context, attrs.C),
									A2(
									$elm$html$Html$map,
									$author$project$ExportForm$DiscreteFormMsg,
									A3($author$project$ExportForm$discretePeriodSelect, context, attrs.C, attrs.aO))
								])),
							function () {
							var _v0 = $author$project$ExportForm$discreteDimensionConfiguration(template);
							switch (_v0.$) {
								case 0:
									var measuresDimensionIncluded = _v0.a;
									var energiesDimensionIncluded = _v0.b;
									return $author$project$ExportForm$discreteDimensions(
										A4($author$project$ExportForm$discreteEntitiesDimensions, context, attrs, measuresDimensionIncluded, energiesDimensionIncluded));
								case 1:
									var measuresDimensionIncluded = _v0.a;
									return $author$project$ExportForm$discreteDimensions(
										A3($author$project$ExportForm$discreteMetersDimensions, context, attrs, measuresDimensionIncluded));
								default:
									return $author$project$Enectiva$View$nothing;
							}
						}(),
							A4($author$project$ExportForm$submitButton, context, disabled, 'export.button.create', tooltip)
						])),
					$author$project$Spinner$overlay(
					_Utils_eq(submitRequest, $krisajenkins$remotedata$RemoteData$Loading))
				]));
	});
var $author$project$ExportForm$EditScheduledDataPointFormSubmitted = {$: 4};
var $author$project$ExportForm$EditScheduledDataPointModeClicked = function (a) {
	return {$: 3, a: a};
};
var $author$project$ExportForm$EditScheduledDataPointNameChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$ExportForm$EditScheduledDataPointShortcutMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$ExportForm$EditScheduledDataSeriesSelected = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Enectiva$I18n$Placeholder = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $author$project$ExportForm$continuousModeInputGroupHelp = F4(
	function (checked, msg, txt, children) {
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center gap-1'),
					$elm$html$Html$Attributes$class('rounded px-2 py-1'),
					$elm$html$Html$Attributes$class('transition-colors duration-75'),
					$elm$html$Html$Attributes$class('border-transparent border border-solid focus-within:border-blue-500 hover:border-blue-500')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('radio'),
								$elm$html$Html$Attributes$name('readings_mode'),
								$elm$html$Html$Attributes$checked(checked),
								$elm$html$Html$Attributes$class('outline-none'),
								$elm$html$Html$Events$onClick(msg)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('inline-block py-2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(txt)
							]))
					]),
				children));
	});
var $author$project$ExportForm$continuousModeLabelPrefix = F2(
	function (translations, mode) {
		switch (mode.$) {
			case 0:
				return A2($author$project$Enectiva$I18n$t, translations, 'export.measures.all');
			case 1:
				return A2($author$project$Enectiva$I18n$t, translations, 'export.measures.first');
			default:
				return A2($author$project$Enectiva$I18n$t, translations, 'export.measures.last');
		}
	});
var $author$project$ExportForm$continuousModeLabel = F2(
	function (translations, mode) {
		var prefix = A2($author$project$ExportForm$continuousModeLabelPrefix, translations, mode);
		switch (mode.$) {
			case 0:
				return prefix;
			case 1:
				var period = mode.a;
				return prefix + (' ' + A2(
					$author$project$Enectiva$I18n$t,
					translations,
					'export.period_select.' + $author$project$Types$periodToString(period)));
			default:
				var period = mode.a;
				return prefix + (' ' + A2(
					$author$project$Enectiva$I18n$t,
					translations,
					'export.period_select.' + $author$project$Types$periodToString(period)));
		}
	});
var $author$project$ExportForm$oneoffPeriodSelect = F4(
	function (translations, tagger, periods, current) {
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('textfield w-auto pr-8'),
					A2(
					$elm$html$Html$Events$on,
					'change',
					A3(
						$elm$core$Basics$composeR,
						$elm$json$Json$Decode$map($author$project$Types$stringToPeriod),
						$elm$json$Json$Decode$map(tagger),
						$elm$html$Html$Events$targetValue))
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$ExportForm$periodOption, translations, current),
				periods));
	});
var $author$project$ExportForm$continuousModeInputGroup = F5(
	function (_v0, availablePeriods, msg, current, mode) {
		var translations = _v0.j;
		var _v1 = _Utils_Tuple2(mode, current);
		_v1$5:
		while (true) {
			switch (_v1.a.$) {
				case 0:
					var _v2 = _v1.a;
					return A4(
						$author$project$ExportForm$continuousModeInputGroupHelp,
						_Utils_eq(current, mode),
						msg(mode),
						A2($author$project$ExportForm$continuousModeLabel, translations, mode),
						_List_Nil);
				case 1:
					switch (_v1.b.$) {
						case 1:
							var period = _v1.b.a;
							return A4(
								$author$project$ExportForm$continuousModeInputGroupHelp,
								true,
								msg(current),
								A2($author$project$ExportForm$continuousModeLabelPrefix, translations, mode),
								_List_fromArray(
									[
										A4(
										$author$project$ExportForm$oneoffPeriodSelect,
										translations,
										A2($elm$core$Basics$composeR, $author$project$ExportForm$First, msg),
										availablePeriods,
										period)
									]));
						case 2:
							var period = _v1.b.a;
							return A4(
								$author$project$ExportForm$continuousModeInputGroupHelp,
								false,
								msg(
									$author$project$ExportForm$First(period)),
								A2(
									$author$project$ExportForm$continuousModeLabel,
									translations,
									$author$project$ExportForm$First(period)),
								_List_Nil);
						default:
							break _v1$5;
					}
				default:
					switch (_v1.b.$) {
						case 2:
							var period = _v1.b.a;
							return A4(
								$author$project$ExportForm$continuousModeInputGroupHelp,
								true,
								msg(current),
								A2($author$project$ExportForm$continuousModeLabelPrefix, translations, mode),
								_List_fromArray(
									[
										A4(
										$author$project$ExportForm$oneoffPeriodSelect,
										translations,
										A2($elm$core$Basics$composeR, $author$project$ExportForm$Last, msg),
										availablePeriods,
										period)
									]));
						case 1:
							var period = _v1.b.a;
							return A4(
								$author$project$ExportForm$continuousModeInputGroupHelp,
								false,
								msg(
									$author$project$ExportForm$Last(period)),
								A2(
									$author$project$ExportForm$continuousModeLabel,
									translations,
									$author$project$ExportForm$Last(period)),
								_List_Nil);
						default:
							break _v1$5;
					}
			}
		}
		return A4(
			$author$project$ExportForm$continuousModeInputGroupHelp,
			_Utils_eq(current, mode),
			msg(mode),
			A2($author$project$ExportForm$continuousModeLabel, translations, mode),
			_List_Nil);
	});
var $author$project$ExportForm$continuousModeSelection = F5(
	function (context, availableModes, measure, msg, mode) {
		var translations = context.j;
		return A2(
			$elm$html$Html$fieldset,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$legend,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Enectiva$I18n$t, translations, 'export.button.create') + (' ' + measure))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex gap-2')
						]),
					A2(
						$elm$core$List$map,
						A4($author$project$ExportForm$continuousModeInputGroup, context, $author$project$ExportForm$continuousPeriods, msg, mode),
						availableModes))
				]));
	});
var $author$project$ExportForm$dataSeriesCheckbox = F3(
	function (msg, selectedDataSeriesIds, dataSeries) {
		return A3(
			$author$project$ExportForm$labeledCheckbox,
			msg(dataSeries.f5),
			A2($elm$core$Set$member, dataSeries.f5, selectedDataSeriesIds),
			_List_fromArray(
				[
					$elm$html$Html$text(dataSeries.gv)
				]));
	});
var $author$project$ExportForm$dataSeriesGrid = F3(
	function (context, msg, selectedDataSeriesIds) {
		var translations = context.j;
		return $elm$core$List$isEmpty(context.bY) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-red-600 error items-center')
				]),
			_List_fromArray(
				[
					A2($author$project$View$tt, translations, 'export.form.no_data_series_to_export')
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid gap-1 grid-consumption-sources w-full')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$ExportForm$dataSeriesCheckbox, msg, selectedDataSeriesIds),
				context.bY));
	});
var $author$project$ExportForm$dataSeriesLegend = function (context) {
	var translations = context.j;
	return A2(
		$elm$html$Html$legend,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex justify-between items-center gap-2')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inline-block relative')
					]),
				_List_fromArray(
					[
						A2($author$project$View$tt, translations, 'export.form.data_series_to_export')
					])),
				$author$project$ExportForm$entityShortcutButtons(context)
			]));
};
var $author$project$Enectiva$I18n$applyOption = function (option) {
	if (!option.$) {
		var placeholder = option.a;
		var value = option.b;
		return A2(
			$elm$regex$Regex$replace,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('%{' + (placeholder + '}'))),
			$elm$core$Basics$always(value));
	} else {
		return $elm$core$Basics$identity;
	}
};
var $author$project$Enectiva$I18n$one = 'one';
var $author$project$Enectiva$I18n$other = 'other';
var $author$project$Enectiva$I18n$fallbackPluralizationFn = function (cnt) {
	if (cnt === 1) {
		return $author$project$Enectiva$I18n$one;
	} else {
		return $author$project$Enectiva$I18n$other;
	}
};
var $author$project$Enectiva$I18n$few = 'few';
var $author$project$Enectiva$I18n$czechPluralizationFn = function (cnt) {
	switch (cnt) {
		case 1:
			return $author$project$Enectiva$I18n$one;
		case 2:
			return $author$project$Enectiva$I18n$few;
		case 3:
			return $author$project$Enectiva$I18n$few;
		case 4:
			return $author$project$Enectiva$I18n$few;
		default:
			return $author$project$Enectiva$I18n$other;
	}
};
var $author$project$Enectiva$I18n$frenchPluralizationFn = function (cnt) {
	switch (cnt) {
		case 0:
			return $author$project$Enectiva$I18n$one;
		case 1:
			return $author$project$Enectiva$I18n$one;
		default:
			return $author$project$Enectiva$I18n$other;
	}
};
var $author$project$Enectiva$I18n$slovakPluralizationFn = $author$project$Enectiva$I18n$czechPluralizationFn;
var $author$project$Enectiva$I18n$pluralizationFns = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('cs', $author$project$Enectiva$I18n$czechPluralizationFn),
			_Utils_Tuple2('sk', $author$project$Enectiva$I18n$slovakPluralizationFn),
			_Utils_Tuple2('fr', $author$project$Enectiva$I18n$frenchPluralizationFn),
			_Utils_Tuple2(
			'hu',
			$elm$core$Basics$always($author$project$Enectiva$I18n$other))
		]));
var $author$project$Enectiva$I18n$countToKeyPathSegment = F2(
	function (_v0, cnt) {
		var l = _v0.a;
		return A3(
			$elm$core$Basics$apR,
			A2($elm$core$Dict$get, l, $author$project$Enectiva$I18n$pluralizationFns),
			$elm$core$Maybe$withDefault($author$project$Enectiva$I18n$fallbackPluralizationFn),
			$elm$core$Basics$abs(cnt));
	});
var $author$project$Enectiva$I18n$providedCount = function (options) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Maybe$Nothing,
		$elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (o) {
					if (o.$ === 1) {
						var cnt = o.a;
						return $elm$core$Maybe$Just(
							$elm$core$Maybe$Just(cnt));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				options)));
};
var $author$project$Enectiva$I18n$tt = F3(
	function (translations, key, options) {
		var _v0 = $author$project$Enectiva$I18n$providedCount(options);
		if (!_v0.$) {
			var cnt = _v0.a;
			var _v1 = A2(
				$author$project$Enectiva$I18n$tHelp,
				translations,
				_Utils_ap(
					$author$project$Enectiva$I18n$keyToKeyPath(key),
					_List_fromArray(
						[
							A2($author$project$Enectiva$I18n$countToKeyPathSegment, translations, cnt)
						])));
			if (_v1.$ === 1) {
				var _v2 = A2(
					$author$project$Enectiva$I18n$tHelp,
					translations,
					_Utils_ap(
						$author$project$Enectiva$I18n$keyToKeyPath(key),
						_List_fromArray(
							[
								A2($author$project$Enectiva$I18n$countToKeyPathSegment, translations, 1)
							])));
				if (_v2.$ === 1) {
					return A2($author$project$Enectiva$I18n$t, translations, key);
				} else {
					var localized = _v2.a;
					return localized;
				}
			} else {
				var localized = _v1.a;
				return A2(
					$author$project$Enectiva$I18n$applyOption,
					A2(
						$author$project$Enectiva$I18n$Placeholder,
						'count',
						$elm$core$String$fromInt(cnt)),
					localized);
			}
		} else {
			return A3(
				$elm$core$List$foldl,
				$author$project$Enectiva$I18n$applyOption,
				A2($author$project$Enectiva$I18n$t, translations, key),
				options);
		}
	});
var $author$project$ExportForm$editScheduledDataPointFormView = F3(
	function (context, attrs, submitRequest) {
		var translations = context.j;
		var scheduledExportDelay = context.bK;
		var disabled = $elm$core$Set$isEmpty(attrs.p);
		var tooltip = disabled ? A2($author$project$Enectiva$I18n$t, translations, 'export.form.disabled_ds_button_tooltip') : '';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-6'),
					$author$project$Spinner$container
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$ExportForm$EditScheduledDataPointFormMsg,
					A2(
						$elm$html$Html$form,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col gap-2 bg-transparent p-0'),
								$elm$html$Html$Events$onSubmit($author$project$ExportForm$EditScheduledDataPointFormSubmitted),
								$elm$html$Html$Attributes$disabled(
								_Utils_eq(submitRequest, $krisajenkins$remotedata$RemoteData$Loading))
							]),
						_List_fromArray(
							[
								A2($author$project$ExportForm$serverErrorsView, context, submitRequest),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex gap-4 items-end')
									]),
								_List_fromArray(
									[
										A3($author$project$ExportForm$nameInput, context, $author$project$ExportForm$EditScheduledDataPointNameChanged, attrs.gv),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('help leading-loose bg-grey-400 transition-colors duration-200 linear hover:bg-grey-700'),
												A2(
												$elm$html$Html$Attributes$attribute,
												'data-help',
												A3(
													$author$project$Enectiva$I18n$tt,
													translations,
													'export.scheduled.delay_note',
													_List_fromArray(
														[
															A2(
															$author$project$Enectiva$I18n$Placeholder,
															'delay',
															$elm$core$String$fromInt(scheduledExportDelay))
														])))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('?')
											]))
									])),
								A2(
								$elm$html$Html$fieldset,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$ExportForm$EditScheduledDataPointShortcutMsg,
										$author$project$ExportForm$dataSeriesLegend(context)),
										A3($author$project$ExportForm$dataSeriesGrid, context, $author$project$ExportForm$EditScheduledDataSeriesSelected, attrs.p)
									])),
								A5(
								$author$project$ExportForm$continuousModeSelection,
								context,
								_List_fromArray(
									[
										$author$project$ExportForm$First(0),
										$author$project$ExportForm$Last(0)
									]),
								A2($author$project$Enectiva$I18n$t, translations, 'export.measures.data_points'),
								$author$project$ExportForm$EditScheduledDataPointModeClicked,
								attrs.h),
								A4($author$project$ExportForm$submitButton, context, disabled, 'export.button.update_scheduled', tooltip)
							]))),
					$author$project$Spinner$overlay(
					_Utils_eq(submitRequest, $krisajenkins$remotedata$RemoteData$Loading))
				]));
	});
var $author$project$ExportForm$EditScheduledMeterSelected = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$ExportForm$EditScheduledReadingFormSubmitted = {$: 4};
var $author$project$ExportForm$EditScheduledReadingModeClicked = function (a) {
	return {$: 3, a: a};
};
var $author$project$ExportForm$EditScheduledReadingNameChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$ExportForm$EditScheduledReadingShortcutMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$ExportForm$editScheduledReadingFormView = F3(
	function (context, attrs, submitRequest) {
		var translations = context.j;
		var scheduledExportDelay = context.bK;
		var disabled = $elm$core$Set$isEmpty(attrs.f);
		var tooltip = disabled ? A2($author$project$Enectiva$I18n$t, translations, 'export.form.disabled_meter_button_tooltip') : '';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-6'),
					$author$project$Spinner$container
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$ExportForm$EditScheduledReadingFormMsg,
					A2(
						$elm$html$Html$form,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col gap-2 bg-transparent p-0'),
								$elm$html$Html$Events$onSubmit($author$project$ExportForm$EditScheduledReadingFormSubmitted),
								$elm$html$Html$Attributes$disabled(
								_Utils_eq(submitRequest, $krisajenkins$remotedata$RemoteData$Loading))
							]),
						_List_fromArray(
							[
								A2($author$project$ExportForm$serverErrorsView, context, submitRequest),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex gap-4 items-end')
									]),
								_List_fromArray(
									[
										A3($author$project$ExportForm$nameInput, context, $author$project$ExportForm$EditScheduledReadingNameChanged, attrs.gv),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('help leading-loose bg-grey-400 transition-colors duration-200 linear hover:bg-grey-700'),
												A2(
												$elm$html$Html$Attributes$attribute,
												'data-help',
												A3(
													$author$project$Enectiva$I18n$tt,
													translations,
													'export.scheduled.delay_note',
													_List_fromArray(
														[
															A2(
															$author$project$Enectiva$I18n$Placeholder,
															'delay',
															$elm$core$String$fromInt(scheduledExportDelay))
														])))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('?')
											]))
									])),
								A2(
								$elm$html$Html$fieldset,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$ExportForm$EditScheduledReadingShortcutMsg,
										A2($author$project$ExportForm$meterGridLegend, context, $author$project$ExportForm$isPhysicalMeter)),
										A4($author$project$ExportForm$meterGrid, context, $author$project$ExportForm$isPhysicalMeter, $author$project$ExportForm$EditScheduledMeterSelected, attrs.f)
									])),
								A5(
								$author$project$ExportForm$continuousModeSelection,
								context,
								_List_fromArray(
									[
										$author$project$ExportForm$First(0),
										$author$project$ExportForm$Last(0)
									]),
								A2($author$project$Enectiva$I18n$t, translations, 'export.measures.readings'),
								$author$project$ExportForm$EditScheduledReadingModeClicked,
								attrs.h),
								A4($author$project$ExportForm$submitButton, context, disabled, 'export.button.update_scheduled', tooltip)
							]))),
					$author$project$Spinner$overlay(
					_Utils_eq(submitRequest, $krisajenkins$remotedata$RemoteData$Loading))
				]));
	});
var $author$project$ExportForm$OneoffDataPointFormSubmitted = {$: 5};
var $author$project$ExportForm$OneoffDataPointModeClicked = function (a) {
	return {$: 4, a: a};
};
var $author$project$ExportForm$OneoffDataPointNameChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$ExportForm$OneoffDataPointPeriodicitySelectionMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$ExportForm$OneoffDataPointShortcutMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$ExportForm$OneoffDataSeriesSelected = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$ExportForm$oneoffDataPointFormView = F3(
	function (context, attrs, submitRequest) {
		var translations = context.j;
		var disabled = $elm$core$Set$isEmpty(attrs.p);
		var tooltip = disabled ? A2($author$project$Enectiva$I18n$t, translations, 'export.form.disabled_ds_button_tooltip') : '';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-6'),
					$author$project$Spinner$container
				]),
			_List_fromArray(
				[
					A2(
					$author$project$ExportForm$changeTemplateButtonRow,
					context,
					A2(
						$elm$html$Html$map,
						$author$project$ExportForm$OneoffDataPointFormMsg,
						A2(
							$elm$html$Html$map,
							$author$project$ExportForm$OneoffDataPointPeriodicitySelectionMsg,
							$author$project$ExportForm$continuousExportPeriodicitySelectionView(context)))),
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-2 bg-transparent p-0'),
							$elm$html$Html$Events$onSubmit(
							$author$project$ExportForm$OneoffDataPointFormMsg($author$project$ExportForm$OneoffDataPointFormSubmitted)),
							$elm$html$Html$Attributes$disabled(
							_Utils_eq(submitRequest, $krisajenkins$remotedata$RemoteData$Loading))
						]),
					_List_fromArray(
						[
							A2($author$project$ExportForm$serverErrorsView, context, submitRequest),
							A3(
							$author$project$ExportForm$nameInput,
							context,
							A2($elm$core$Basics$composeR, $author$project$ExportForm$OneoffDataPointNameChanged, $author$project$ExportForm$OneoffDataPointFormMsg),
							attrs.gv),
							A2($author$project$ExportForm$rangeInput, context, attrs.C),
							A2(
							$elm$html$Html$map,
							$author$project$ExportForm$OneoffDataPointFormMsg,
							A2(
								$elm$html$Html$fieldset,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$ExportForm$OneoffDataPointShortcutMsg,
										$author$project$ExportForm$dataSeriesLegend(context)),
										A3($author$project$ExportForm$dataSeriesGrid, context, $author$project$ExportForm$OneoffDataSeriesSelected, attrs.p)
									]))),
							A5(
							$author$project$ExportForm$continuousModeSelection,
							context,
							_List_fromArray(
								[
									$author$project$ExportForm$All,
									$author$project$ExportForm$First(0),
									$author$project$ExportForm$Last(0)
								]),
							A2($author$project$Enectiva$I18n$t, translations, 'export.measures.data_points'),
							A2($elm$core$Basics$composeR, $author$project$ExportForm$OneoffDataPointModeClicked, $author$project$ExportForm$OneoffDataPointFormMsg),
							attrs.h),
							A4($author$project$ExportForm$submitButton, context, disabled, 'export.button.create', tooltip)
						])),
					$author$project$Spinner$overlay(
					_Utils_eq(submitRequest, $krisajenkins$remotedata$RemoteData$Loading))
				]));
	});
var $author$project$ExportForm$OneoffMeterSelected = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$ExportForm$OneoffReadingFormSubmitted = {$: 5};
var $author$project$ExportForm$OneoffReadingModeClicked = function (a) {
	return {$: 4, a: a};
};
var $author$project$ExportForm$OneoffReadingNameChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$ExportForm$OneoffReadingPeriodicitySelectionMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$ExportForm$OneoffReadingShortcutMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$ExportForm$oneoffReadingFormView = F3(
	function (context, attrs, submitRequest) {
		var translations = context.j;
		var disabled = $elm$core$Set$isEmpty(attrs.f);
		var tooltip = disabled ? A2($author$project$Enectiva$I18n$t, translations, 'export.form.disabled_meter_button_tooltip') : '';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-6'),
					$author$project$Spinner$container
				]),
			_List_fromArray(
				[
					A2(
					$author$project$ExportForm$changeTemplateButtonRow,
					context,
					A2(
						$elm$html$Html$map,
						$author$project$ExportForm$OneoffReadingFormMsg,
						A2(
							$elm$html$Html$map,
							$author$project$ExportForm$OneoffReadingPeriodicitySelectionMsg,
							$author$project$ExportForm$continuousExportPeriodicitySelectionView(context)))),
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-2 bg-transparent p-0'),
							$elm$html$Html$Events$onSubmit(
							$author$project$ExportForm$OneoffReadingFormMsg($author$project$ExportForm$OneoffReadingFormSubmitted)),
							$elm$html$Html$Attributes$disabled(
							_Utils_eq(submitRequest, $krisajenkins$remotedata$RemoteData$Loading))
						]),
					_List_fromArray(
						[
							A2($author$project$ExportForm$serverErrorsView, context, submitRequest),
							A3(
							$author$project$ExportForm$nameInput,
							context,
							A2($elm$core$Basics$composeR, $author$project$ExportForm$OneoffReadingNameChanged, $author$project$ExportForm$OneoffReadingFormMsg),
							attrs.gv),
							A2($author$project$ExportForm$rangeInput, context, attrs.C),
							A2(
							$elm$html$Html$map,
							$author$project$ExportForm$OneoffReadingFormMsg,
							A2(
								$elm$html$Html$fieldset,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$ExportForm$OneoffReadingShortcutMsg,
										A2($author$project$ExportForm$meterGridLegend, context, $author$project$ExportForm$isPhysicalMeter)),
										A4($author$project$ExportForm$meterGrid, context, $author$project$ExportForm$isPhysicalMeter, $author$project$ExportForm$OneoffMeterSelected, attrs.f)
									]))),
							A5(
							$author$project$ExportForm$continuousModeSelection,
							context,
							_List_fromArray(
								[
									$author$project$ExportForm$All,
									$author$project$ExportForm$First(0),
									$author$project$ExportForm$Last(0)
								]),
							A2($author$project$Enectiva$I18n$t, translations, 'export.measures.readings'),
							A2($elm$core$Basics$composeR, $author$project$ExportForm$OneoffReadingModeClicked, $author$project$ExportForm$OneoffReadingFormMsg),
							attrs.h),
							A4($author$project$ExportForm$submitButton, context, disabled, 'export.button.create', tooltip)
						])),
					$author$project$Spinner$overlay(
					_Utils_eq(submitRequest, $krisajenkins$remotedata$RemoteData$Loading))
				]));
	});
var $author$project$ExportForm$ScheduledDataPointFormSubmitted = {$: 5};
var $author$project$ExportForm$ScheduledDataPointModeClicked = function (a) {
	return {$: 4, a: a};
};
var $author$project$ExportForm$ScheduledDataPointNameChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$ExportForm$ScheduledDataPointPeriodicitySelectionMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$ExportForm$ScheduledDataPointShortcutMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$ExportForm$ScheduledDataSeriesSelected = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$ExportForm$scheduledDataPointFormView = F3(
	function (context, attrs, submitRequest) {
		var translations = context.j;
		var scheduledExportDelay = context.bK;
		var disabled = $elm$core$Set$isEmpty(attrs.p);
		var tooltip = disabled ? A2($author$project$Enectiva$I18n$t, translations, 'export.form.disabled_ds_button_tooltip') : '';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-6'),
					$author$project$Spinner$container
				]),
			_List_fromArray(
				[
					A2(
					$author$project$ExportForm$changeTemplateButtonRow,
					context,
					A2(
						$elm$html$Html$map,
						$author$project$ExportForm$ScheduledDataPointFormMsg,
						A2(
							$elm$html$Html$map,
							$author$project$ExportForm$ScheduledDataPointPeriodicitySelectionMsg,
							$author$project$ExportForm$continuousExportPeriodicitySelectionView(context)))),
					A2(
					$elm$html$Html$map,
					$author$project$ExportForm$ScheduledDataPointFormMsg,
					A2(
						$elm$html$Html$form,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col gap-2 bg-transparent p-0'),
								$elm$html$Html$Events$onSubmit($author$project$ExportForm$ScheduledDataPointFormSubmitted),
								$elm$html$Html$Attributes$disabled(
								_Utils_eq(submitRequest, $krisajenkins$remotedata$RemoteData$Loading))
							]),
						_List_fromArray(
							[
								A2($author$project$ExportForm$serverErrorsView, context, submitRequest),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex gap-4 items-end')
									]),
								_List_fromArray(
									[
										A3($author$project$ExportForm$nameInput, context, $author$project$ExportForm$ScheduledDataPointNameChanged, attrs.gv),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('help leading-loose bg-grey-400 transition-colors duration-200 linear hover:bg-grey-700'),
												A2(
												$elm$html$Html$Attributes$attribute,
												'data-help',
												A3(
													$author$project$Enectiva$I18n$tt,
													translations,
													'export.scheduled.delay_note',
													_List_fromArray(
														[
															A2(
															$author$project$Enectiva$I18n$Placeholder,
															'delay',
															$elm$core$String$fromInt(scheduledExportDelay))
														])))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('?')
											]))
									])),
								A2(
								$elm$html$Html$fieldset,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$ExportForm$ScheduledDataPointShortcutMsg,
										$author$project$ExportForm$dataSeriesLegend(context)),
										A3($author$project$ExportForm$dataSeriesGrid, context, $author$project$ExportForm$ScheduledDataSeriesSelected, attrs.p)
									])),
								A5(
								$author$project$ExportForm$continuousModeSelection,
								context,
								_List_fromArray(
									[
										$author$project$ExportForm$First(0),
										$author$project$ExportForm$Last(0)
									]),
								A2($author$project$Enectiva$I18n$t, translations, 'export.measures.data_points'),
								$author$project$ExportForm$ScheduledDataPointModeClicked,
								attrs.h),
								A4($author$project$ExportForm$submitButton, context, disabled, 'export.button.create_scheduled', tooltip)
							]))),
					$author$project$Spinner$overlay(
					_Utils_eq(submitRequest, $krisajenkins$remotedata$RemoteData$Loading))
				]));
	});
var $author$project$ExportForm$ScheduledMeterSelected = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$ExportForm$ScheduledReadingFormSubmitted = {$: 5};
var $author$project$ExportForm$ScheduledReadingModeClicked = function (a) {
	return {$: 4, a: a};
};
var $author$project$ExportForm$ScheduledReadingNameChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$ExportForm$ScheduledReadingPeriodicitySelectionMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$ExportForm$ScheduledReadingShortcutMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$ExportForm$scheduledReadingFormView = F3(
	function (context, attrs, submitRequest) {
		var translations = context.j;
		var scheduledExportDelay = context.bK;
		var disabled = $elm$core$Set$isEmpty(attrs.f);
		var tooltip = disabled ? A2($author$project$Enectiva$I18n$t, translations, 'export.form.disabled_meter_button_tooltip') : '';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-6'),
					$author$project$Spinner$container
				]),
			_List_fromArray(
				[
					A2(
					$author$project$ExportForm$changeTemplateButtonRow,
					context,
					A2(
						$elm$html$Html$map,
						$author$project$ExportForm$ScheduledReadingFormMsg,
						A2(
							$elm$html$Html$map,
							$author$project$ExportForm$ScheduledReadingPeriodicitySelectionMsg,
							$author$project$ExportForm$continuousExportPeriodicitySelectionView(context)))),
					A2(
					$elm$html$Html$map,
					$author$project$ExportForm$ScheduledReadingFormMsg,
					A2(
						$elm$html$Html$form,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col gap-2 bg-transparent p-0'),
								$elm$html$Html$Events$onSubmit($author$project$ExportForm$ScheduledReadingFormSubmitted),
								$elm$html$Html$Attributes$disabled(
								_Utils_eq(submitRequest, $krisajenkins$remotedata$RemoteData$Loading))
							]),
						_List_fromArray(
							[
								A2($author$project$ExportForm$serverErrorsView, context, submitRequest),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex gap-4 items-end')
									]),
								_List_fromArray(
									[
										A3($author$project$ExportForm$nameInput, context, $author$project$ExportForm$ScheduledReadingNameChanged, attrs.gv),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('help leading-loose bg-grey-400 transition-colors duration-200 linear hover:bg-grey-700'),
												A2(
												$elm$html$Html$Attributes$attribute,
												'data-help',
												A3(
													$author$project$Enectiva$I18n$tt,
													translations,
													'export.scheduled.delay_note',
													_List_fromArray(
														[
															A2(
															$author$project$Enectiva$I18n$Placeholder,
															'delay',
															$elm$core$String$fromInt(scheduledExportDelay))
														])))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('?')
											]))
									])),
								A2(
								$elm$html$Html$fieldset,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$ExportForm$ScheduledReadingShortcutMsg,
										A2($author$project$ExportForm$meterGridLegend, context, $author$project$ExportForm$isPhysicalMeter)),
										A4($author$project$ExportForm$meterGrid, context, $author$project$ExportForm$isPhysicalMeter, $author$project$ExportForm$ScheduledMeterSelected, attrs.f)
									])),
								A5(
								$author$project$ExportForm$continuousModeSelection,
								context,
								_List_fromArray(
									[
										$author$project$ExportForm$First(0),
										$author$project$ExportForm$Last(0)
									]),
								A2($author$project$Enectiva$I18n$t, translations, 'export.measures.readings'),
								$author$project$ExportForm$ScheduledReadingModeClicked,
								attrs.h),
								A4($author$project$ExportForm$submitButton, context, disabled, 'export.button.create_scheduled', tooltip)
							]))),
					$author$project$Spinner$overlay(
					_Utils_eq(submitRequest, $krisajenkins$remotedata$RemoteData$Loading))
				]));
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$View$localizeUrl = F2(
	function (url, locale) {
		return '/' + (locale + url);
	});
var $author$project$ExportForm$manageTemplatesButton = function (_v0) {
	var translations = _v0.j;
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('button--with-icon button--templates subdued-button'),
				$elm$html$Html$Attributes$href(
				A2(
					$author$project$View$localizeUrl,
					'/export_templates',
					$author$project$Enectiva$I18n$locale(translations)))
			]),
		_List_fromArray(
			[
				A2($author$project$View$tt, translations, 'export.template.manage_templates')
			]));
};
var $author$project$ExportForm$TemplateSelected = $elm$core$Basics$identity;
var $author$project$View$intTargetValueDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $elm$core$String$toInt(s);
		if (!_v0.$) {
			var i = _v0.a;
			return $elm$json$Json$Decode$succeed(i);
		} else {
			return $elm$json$Json$Decode$fail('Invalid int string `' + (s + '`'));
		}
	},
	$elm$html$Html$Events$targetValue);
var $author$project$ExportForm$noTemplateSelectedOption = function (_v0) {
	var translations = _v0.j;
	return A2(
		$elm$html$Html$option,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value('')
			]),
		_List_fromArray(
			[
				A2($author$project$View$tt, translations, 'activerecord.attributes.export.choose_template')
			]));
};
var $author$project$ExportForm$templateOption = function (template) {
	return A2(
		$elm$html$Html$option,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value(
				$elm$core$String$fromInt(template.f5))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(template.gv)
			]));
};
var $author$project$ExportForm$templateSelectionSelect = function (context) {
	return A2(
		$elm$html$Html$select,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$Events$on,
				'change',
				A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$View$intTargetValueDecoder)),
				$elm$html$Html$Attributes$class('textfield')
			]),
		A2(
			$elm$core$List$cons,
			$author$project$ExportForm$noTemplateSelectedOption(context),
			A2($elm$core$List$map, $author$project$ExportForm$templateOption, context.cj)));
};
var $author$project$ExportForm$templateSelectionView = function (context) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex justify-between')
			]),
		_List_fromArray(
			[
				$author$project$ExportForm$templateSelectionSelect(context),
				A2(
				$author$project$Enectiva$View$viewIf,
				function (_v0) {
					return $author$project$ExportForm$manageTemplatesButton(context);
				},
				context.dr)
			]));
};
var $author$project$ExportForm$viewHelp = function (model) {
	var _v0 = model.al;
	switch (_v0.$) {
		case 0:
			return A2(
				$elm$html$Html$map,
				$author$project$ExportForm$TemplateSelectionMsg,
				$author$project$ExportForm$templateSelectionView(model));
		case 2:
			return A2(
				$author$project$ExportForm$changeTemplateButtonRow,
				model,
				A2(
					$elm$html$Html$map,
					$author$project$ExportForm$ReadingExportPeriodicitySelectionMsg,
					$author$project$ExportForm$continuousExportPeriodicitySelectionView(model)));
		case 3:
			return A2(
				$author$project$ExportForm$changeTemplateButtonRow,
				model,
				A2(
					$elm$html$Html$map,
					$author$project$ExportForm$DataPointExportPeriodicitySelectionMsg,
					$author$project$ExportForm$continuousExportPeriodicitySelectionView(model)));
		case 4:
			var attrs = _v0.b;
			var submitRequest = _v0.c;
			return A3($author$project$ExportForm$oneoffReadingFormView, model, attrs, submitRequest);
		case 5:
			var attrs = _v0.b;
			var submitRequest = _v0.c;
			return A3($author$project$ExportForm$oneoffDataPointFormView, model, attrs, submitRequest);
		case 6:
			var attrs = _v0.b;
			var submitRequest = _v0.c;
			return A3($author$project$ExportForm$scheduledReadingFormView, model, attrs, submitRequest);
		case 7:
			var attrs = _v0.b;
			var submitRequest = _v0.c;
			return A3($author$project$ExportForm$scheduledDataPointFormView, model, attrs, submitRequest);
		case 1:
			var template = _v0.a;
			var attrs = _v0.b;
			var submitRequest = _v0.c;
			return A4($author$project$ExportForm$discreteExportFormView, model, template, attrs, submitRequest);
		case 8:
			var attrs = _v0.b;
			var submitRequest = _v0.c;
			return A3($author$project$ExportForm$editScheduledReadingFormView, model, attrs, submitRequest);
		default:
			var attrs = _v0.b;
			var submitRequest = _v0.c;
			return A3($author$project$ExportForm$editScheduledDataPointFormView, model, attrs, submitRequest);
	}
};
var $author$project$ExportForm$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$ExportForm$viewHelp(model)
			]));
};
var $author$project$ExportForm$main = $elm$browser$Browser$element(
	{
		ij: $author$project$ExportForm$init,
		hf: function (m) {
			if (!m.$) {
				var model = m.a;
				return $author$project$ExportForm$subscriptions(model);
			} else {
				return $elm$core$Platform$Sub$none;
			}
		},
		jl: F2(
			function (msg, m) {
				if (!m.$) {
					var model = m.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						$author$project$ExportForm$ValidModel,
						A2($author$project$ExportForm$update, msg, model));
				} else {
					return $author$project$Enectiva$Util$noCmd(m);
				}
			}),
		jn: function (m) {
			if (!m.$) {
				var model = m.a;
				return $author$project$ExportForm$view(model);
			} else {
				var err = m.a;
				return $elm$html$Html$text(err);
			}
		}
	});
/*
_Platform_export({'ExportForm':{'init':$author$project$ExportForm$main($elm$json$Json$Decode$value)(0)}});}(this));
*/
export const Elm = {'ExportForm':{'init':$author$project$ExportForm$main($elm$json$Json$Decode$value)(0)}};
  